// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiV1AlertsByUuidData, DeleteApiV1AlertsByUuidErrors, DeleteApiV1AlertsByUuidResponses, DeleteApiV1AuditData, DeleteApiV1AuditErrors, DeleteApiV1AuditResponses, DeleteApiV1AuthAccessRevokeData, DeleteApiV1AuthAccessRevokeErrors, DeleteApiV1AuthAccessRevokeResponses, DeleteApiV1AuthRefreshRevokeData, DeleteApiV1AuthRefreshRevokeErrors, DeleteApiV1AuthRefreshRevokeResponses, DeleteApiV1AuxiliaryByUuidData, DeleteApiV1AuxiliaryByUuidErrors, DeleteApiV1AuxiliaryByUuidResponses, DeleteApiV1ClinicalStudiesAdminProcedureByUuidData, DeleteApiV1ClinicalStudiesAdminProcedureByUuidErrors, DeleteApiV1ClinicalStudiesAdminProcedureByUuidResponses, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidErrors, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesEnrollmentByUuidData, DeleteApiV1ClinicalStudiesEnrollmentByUuidErrors, DeleteApiV1ClinicalStudiesEnrollmentByUuidResponses, DeleteApiV1ClinicalStudiesStudyVisitByUuidData, DeleteApiV1ClinicalStudiesStudyVisitByUuidErrors, DeleteApiV1ClinicalStudiesStudyVisitByUuidResponses, DeleteApiV1ClinicsByUuidData, DeleteApiV1ClinicsByUuidErrors, DeleteApiV1ClinicsByUuidResponses, DeleteApiV1ComputedByUuidData, DeleteApiV1ComputedByUuidErrors, DeleteApiV1ComputedByUuidResponses, DeleteApiV1DerivedPpgByPpgUuidData, DeleteApiV1DerivedPpgByPpgUuidErrors, DeleteApiV1DerivedPpgByPpgUuidResponses, DeleteApiV1DiagnosesByUuidData, DeleteApiV1DiagnosesByUuidErrors, DeleteApiV1DiagnosesByUuidResponses, DeleteApiV1EcgByUuidData, DeleteApiV1EcgByUuidErrors, DeleteApiV1EcgByUuidResponses, DeleteApiV1EcgDerivedEcgByEcgUuidData, DeleteApiV1EcgDerivedEcgByEcgUuidErrors, DeleteApiV1EcgDerivedEcgByEcgUuidResponses, DeleteApiV1EventsByUuidData, DeleteApiV1EventsByUuidErrors, DeleteApiV1EventsByUuidResponses, DeleteApiV1LimitersByUuidData, DeleteApiV1LimitersByUuidErrors, DeleteApiV1LimitersByUuidResponses, DeleteApiV1MedicaldataByUuidData, DeleteApiV1MedicaldataByUuidErrors, DeleteApiV1MedicaldataByUuidResponses, DeleteApiV1MedicalReportsByUuidData, DeleteApiV1MedicalReportsByUuidErrors, DeleteApiV1MedicalReportsByUuidResponses, DeleteApiV1MedicationsByUuidData, DeleteApiV1MedicationsByUuidErrors, DeleteApiV1MedicationsByUuidResponses, DeleteApiV1MessagingByUuidData, DeleteApiV1MessagingByUuidErrors, DeleteApiV1MessagingByUuidResponses, DeleteApiV1MfaTotpData, DeleteApiV1MfaTotpResponses, DeleteApiV1MfaWebauthnByCredentialUuidData, DeleteApiV1MfaWebauthnByCredentialUuidErrors, DeleteApiV1MfaWebauthnByCredentialUuidResponses, DeleteApiV1MonitoringSettingsMonitoringByUuidData, DeleteApiV1MonitoringSettingsMonitoringByUuidErrors, DeleteApiV1MonitoringSettingsMonitoringByUuidResponses, DeleteApiV1MonitoringSettingsQuestionnairesByUuidData, DeleteApiV1MonitoringSettingsQuestionnairesByUuidErrors, DeleteApiV1MonitoringSettingsQuestionnairesByUuidResponses, DeleteApiV1PatientsByPatientIdData, DeleteApiV1PatientsByPatientIdErrors, DeleteApiV1PatientsByPatientIdResponses, DeleteApiV1PhysiciansByUuidData, DeleteApiV1PhysiciansByUuidErrors, DeleteApiV1PhysiciansByUuidResponses, DeleteApiV1PpgByUuidData, DeleteApiV1PpgByUuidErrors, DeleteApiV1PpgByUuidResponses, DeleteApiV1PushTokensUnregisterByTokenData, DeleteApiV1PushTokensUnregisterByTokenErrors, DeleteApiV1PushTokensUnregisterByTokenResponses, DeleteApiV1PushTokensUnregisterByUuidByTokenData, DeleteApiV1PushTokensUnregisterByUuidByTokenErrors, DeleteApiV1PushTokensUnregisterByUuidByTokenResponses, DeleteApiV1QuestionnairesByUuidData, DeleteApiV1QuestionnairesByUuidErrors, DeleteApiV1QuestionnairesByUuidResponses, DeleteApiV1SchedulesByUuidData, DeleteApiV1SchedulesByUuidErrors, DeleteApiV1SchedulesByUuidResponses, DeleteApiV1ServiceAccountsKeysByKeyUuidData, DeleteApiV1ServiceAccountsKeysByKeyUuidErrors, DeleteApiV1ServiceAccountsKeysByKeyUuidResponses, DeleteApiV1StudyTextByUuidData, DeleteApiV1StudyTextByUuidErrors, DeleteApiV1StudyTextByUuidResponses, DeleteApiV1SymptomsByUuidData, DeleteApiV1SymptomsByUuidErrors, DeleteApiV1SymptomsByUuidResponses, DeleteApiV1ThresholdsByUuidData, DeleteApiV1ThresholdsByUuidErrors, DeleteApiV1ThresholdsByUuidResponses, DeleteApiV1UsersByUuidData, DeleteApiV1UsersByUuidErrors, DeleteApiV1UsersByUuidResponses, GetApiHealthcheckerData, GetApiHealthcheckerResponses, GetApiHealthData, GetApiHealthResponses, GetApiInfoData, GetApiInfoErrors, GetApiInfoResponses, GetApiV1AiOutputsByUuidFeedbackData, GetApiV1AiOutputsByUuidFeedbackErrors, GetApiV1AiOutputsByUuidFeedbackResponses, GetApiV1AlertsAuditRoomData, GetApiV1AlertsAuditRoomErrors, GetApiV1AlertsAuditRoomResponses, GetApiV1AlertsData, GetApiV1AlertsErrors, GetApiV1AlertsMedicalWaitingRoomData, GetApiV1AlertsMedicalWaitingRoomErrors, GetApiV1AlertsMedicalWaitingRoomResponses, GetApiV1AlertsResponses, GetApiV1AlertsSourceDataByUuidData, GetApiV1AlertsSourceDataByUuidErrors, GetApiV1AlertsSourceDataByUuidResponses, GetApiV1AlertsTechnicalWaitingRoomData, GetApiV1AlertsTechnicalWaitingRoomErrors, GetApiV1AlertsTechnicalWaitingRoomResponses, GetApiV1AnalyticsAlertsData, GetApiV1AnalyticsAlertsErrors, GetApiV1AnalyticsAlertsResponses, GetApiV1AnalyticsAuditData, GetApiV1AnalyticsAuditErrors, GetApiV1AnalyticsAuditResponses, GetApiV1AnalyticsComputedData, GetApiV1AnalyticsComputedErrors, GetApiV1AnalyticsComputedResponses, GetApiV1AnalyticsEcgData, GetApiV1AnalyticsEcgErrors, GetApiV1AnalyticsEcgResponses, GetApiV1AnalyticsEventsData, GetApiV1AnalyticsEventsErrors, GetApiV1AnalyticsEventsResponses, GetApiV1AnalyticsPpgData, GetApiV1AnalyticsPpgErrors, GetApiV1AnalyticsPpgResponses, GetApiV1AuditData, GetApiV1AuditErrors, GetApiV1AuditResponses, GetApiV1AuthAdminLogoutByUuidData, GetApiV1AuthAdminLogoutByUuidErrors, GetApiV1AuthAdminLogoutByUuidResponses, GetApiV1AuthIsFreshData, GetApiV1AuthIsFreshErrors, GetApiV1AuthIsFreshResponses, GetApiV1AuthLogoutAllData, GetApiV1AuthLogoutAllErrors, GetApiV1AuthLogoutAllResponses, GetApiV1AuthLogoutData, GetApiV1AuthLogoutErrors, GetApiV1AuthLogoutResponses, GetApiV1AuthRefreshData, GetApiV1AuthRefreshErrors, GetApiV1AuthRefreshResponses, GetApiV1AuxiliaryByUuidData, GetApiV1AuxiliaryByUuidErrors, GetApiV1AuxiliaryByUuidResponses, GetApiV1AuxiliaryData, GetApiV1AuxiliaryEcgByEcgUuidData, GetApiV1AuxiliaryEcgByEcgUuidErrors, GetApiV1AuxiliaryEcgByEcgUuidResponses, GetApiV1AuxiliaryErrors, GetApiV1AuxiliaryPpgByPpgUuidData, GetApiV1AuxiliaryPpgByPpgUuidErrors, GetApiV1AuxiliaryPpgByPpgUuidResponses, GetApiV1AuxiliaryResponses, GetApiV1BillingAccountData, GetApiV1BillingAccountErrors, GetApiV1BillingAccountResponses, GetApiV1BillingLedgerData, GetApiV1BillingLedgerErrors, GetApiV1BillingLedgerResponses, GetApiV1BillingScreeningUsersData, GetApiV1BillingScreeningUsersErrors, GetApiV1BillingScreeningUsersResponses, GetApiV1BillingUsersByUserUuidAccountData, GetApiV1BillingUsersByUserUuidAccountErrors, GetApiV1BillingUsersByUserUuidAccountResponses, GetApiV1ClinicalStudiesByStudyAcronymDefinitionData, GetApiV1ClinicalStudiesByStudyAcronymDefinitionErrors, GetApiV1ClinicalStudiesByStudyAcronymDefinitionResponses, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillData, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillErrors, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillResponses, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallData, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallErrors, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallResponses, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdData, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdErrors, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdResponses, GetApiV1ClinicalStudiesByStudyAcronymVisitsData, GetApiV1ClinicalStudiesByStudyAcronymVisitsErrors, GetApiV1ClinicalStudiesByStudyAcronymVisitsResponses, GetApiV1ClinicalStudiesByVisitUuidDataPreFillData, GetApiV1ClinicalStudiesByVisitUuidDataPreFillErrors, GetApiV1ClinicalStudiesByVisitUuidDataPreFillResponses, GetApiV1ClinicalStudiesCalendarData, GetApiV1ClinicalStudiesCalendarErrors, GetApiV1ClinicalStudiesCalendarResponses, GetApiV1ClinicalStudiesData, GetApiV1ClinicalStudiesErrors, GetApiV1ClinicalStudiesResponses, GetApiV1ClinicsData, GetApiV1ClinicsErrors, GetApiV1ClinicsResponses, GetApiV1ComputedData, GetApiV1ComputedErrors, GetApiV1ComputedLastData, GetApiV1ComputedLastErrors, GetApiV1ComputedLastResponses, GetApiV1ComputedPpgByPpgUuidData, GetApiV1ComputedPpgByPpgUuidErrors, GetApiV1ComputedPpgByPpgUuidLvfpIndicationData, GetApiV1ComputedPpgByPpgUuidLvfpIndicationErrors, GetApiV1ComputedPpgByPpgUuidLvfpIndicationResponses, GetApiV1ComputedPpgByPpgUuidResponses, GetApiV1ComputedResponses, GetApiV1DerivedByUuidData, GetApiV1DerivedByUuidErrors, GetApiV1DerivedByUuidResponses, GetApiV1DerivedData, GetApiV1DerivedErrors, GetApiV1DerivedPpgByPpgUuidData, GetApiV1DerivedPpgByPpgUuidErrors, GetApiV1DerivedPpgByPpgUuidResponses, GetApiV1DerivedResponses, GetApiV1DiagnosesData, GetApiV1DiagnosesErrors, GetApiV1DiagnosesListData, GetApiV1DiagnosesListErrors, GetApiV1DiagnosesListResponses, GetApiV1DiagnosesResponses, GetApiV1EcgByUuidData, GetApiV1EcgByUuidErrors, GetApiV1EcgByUuidResponses, GetApiV1EcgData, GetApiV1EcgDerivedByUuidData, GetApiV1EcgDerivedByUuidErrors, GetApiV1EcgDerivedByUuidResponses, GetApiV1EcgDerivedData, GetApiV1EcgDerivedEcgByEcgUuidData, GetApiV1EcgDerivedEcgByEcgUuidErrors, GetApiV1EcgDerivedEcgByEcgUuidResponses, GetApiV1EcgDerivedErrors, GetApiV1EcgDerivedResponses, GetApiV1EcgDerivedScpCodesData, GetApiV1EcgDerivedScpCodesErrors, GetApiV1EcgDerivedScpCodesResponses, GetApiV1EcgErrors, GetApiV1EcgResponses, GetApiV1EventsCategoriesData, GetApiV1EventsCategoriesErrors, GetApiV1EventsCategoriesResponses, GetApiV1EventsData, GetApiV1EventsErrors, GetApiV1EventsResponses, GetApiV1HfBasicMedDataByPatientIdData, GetApiV1HfBasicMedDataByPatientIdErrors, GetApiV1HfBasicMedDataByPatientIdResponses, GetApiV1HfComorbiditiesByPatientIdData, GetApiV1HfComorbiditiesByPatientIdErrors, GetApiV1HfComorbiditiesByPatientIdResponses, GetApiV1HfExamsByPatientIdData, GetApiV1HfExamsByPatientIdErrors, GetApiV1HfExamsByPatientIdResponses, GetApiV1HfLabDataByPatientIdData, GetApiV1HfLabDataByPatientIdErrors, GetApiV1HfLabDataByPatientIdResponses, GetApiV1HfSymptomsByPatientIdData, GetApiV1HfSymptomsByPatientIdErrors, GetApiV1HfSymptomsByPatientIdResponses, GetApiV1HfVitalsByPatientIdData, GetApiV1HfVitalsByPatientIdErrors, GetApiV1HfVitalsByPatientIdResponses, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidData, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidErrors, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidResponses, GetApiV1LabelstudioTaskByProjectIdByPpgUuidData, GetApiV1LabelstudioTaskByProjectIdByPpgUuidErrors, GetApiV1LabelstudioTaskByProjectIdByPpgUuidResponses, GetApiV1LimitersData, GetApiV1LimitersErrors, GetApiV1LimitersResponses, GetApiV1MedicaldataData, GetApiV1MedicaldataErrors, GetApiV1MedicaldataLastData, GetApiV1MedicaldataLastErrors, GetApiV1MedicaldataLastResponses, GetApiV1MedicaldataListData, GetApiV1MedicaldataListErrors, GetApiV1MedicaldataListResponses, GetApiV1MedicaldataResponses, GetApiV1MedicalReportsByUuidData, GetApiV1MedicalReportsByUuidDownloadUrlData, GetApiV1MedicalReportsByUuidDownloadUrlErrors, GetApiV1MedicalReportsByUuidDownloadUrlResponses, GetApiV1MedicalReportsByUuidErrors, GetApiV1MedicalReportsByUuidExtractionData, GetApiV1MedicalReportsByUuidExtractionErrors, GetApiV1MedicalReportsByUuidExtractionResponses, GetApiV1MedicalReportsByUuidResponses, GetApiV1MedicalReportsByUuidUploadUrlData, GetApiV1MedicalReportsByUuidUploadUrlErrors, GetApiV1MedicalReportsByUuidUploadUrlResponses, GetApiV1MedicalReportsData, GetApiV1MedicalReportsDownloadByUuidData, GetApiV1MedicalReportsDownloadByUuidErrors, GetApiV1MedicalReportsDownloadByUuidResponses, GetApiV1MedicalReportsErrors, GetApiV1MedicalReportsResponses, GetApiV1MedicationsData, GetApiV1MedicationsErrors, GetApiV1MedicationsMedicationGroupsData, GetApiV1MedicationsMedicationGroupsErrors, GetApiV1MedicationsMedicationGroupsResponses, GetApiV1MedicationsResponses, GetApiV1MessagingByPatientIdData, GetApiV1MessagingByPatientIdErrors, GetApiV1MessagingByPatientIdResponses, GetApiV1MessagingData, GetApiV1MessagingErrors, GetApiV1MessagingResponses, GetApiV1MfaStatusData, GetApiV1MfaStatusResponses, GetApiV1MonitoringSettingsMonitoringByPatientIdData, GetApiV1MonitoringSettingsMonitoringByPatientIdErrors, GetApiV1MonitoringSettingsMonitoringByPatientIdResponses, GetApiV1MonitoringSettingsMonitoringData, GetApiV1MonitoringSettingsMonitoringErrors, GetApiV1MonitoringSettingsMonitoringResponses, GetApiV1MonitoringSettingsQuestionnairesData, GetApiV1MonitoringSettingsQuestionnairesErrors, GetApiV1MonitoringSettingsQuestionnairesResponses, GetApiV1PatientsByPatientIdAlertsData, GetApiV1PatientsByPatientIdAlertsErrors, GetApiV1PatientsByPatientIdAlertsResponses, GetApiV1PatientsByPatientIdComputedData, GetApiV1PatientsByPatientIdComputedErrors, GetApiV1PatientsByPatientIdComputedResponses, GetApiV1PatientsByPatientIdConsentData, GetApiV1PatientsByPatientIdConsentErrors, GetApiV1PatientsByPatientIdConsentResponses, GetApiV1PatientsByPatientIdData, GetApiV1PatientsByPatientIdDerivedData, GetApiV1PatientsByPatientIdDerivedErrors, GetApiV1PatientsByPatientIdDerivedResponses, GetApiV1PatientsByPatientIdDiagnosesData, GetApiV1PatientsByPatientIdDiagnosesErrors, GetApiV1PatientsByPatientIdDiagnosesResponses, GetApiV1PatientsByPatientIdErrors, GetApiV1PatientsByPatientIdEventsData, GetApiV1PatientsByPatientIdEventsErrors, GetApiV1PatientsByPatientIdEventsResponses, GetApiV1PatientsByPatientIdGdmtData, GetApiV1PatientsByPatientIdGdmtErrors, GetApiV1PatientsByPatientIdGdmtResponses, GetApiV1PatientsByPatientIdHealthProData, GetApiV1PatientsByPatientIdHealthProErrors, GetApiV1PatientsByPatientIdHealthProResponses, GetApiV1PatientsByPatientIdMeasurementsData, GetApiV1PatientsByPatientIdMeasurementsErrors, GetApiV1PatientsByPatientIdMeasurementsResponses, GetApiV1PatientsByPatientIdMedicaldataData, GetApiV1PatientsByPatientIdMedicaldataErrors, GetApiV1PatientsByPatientIdMedicaldataResponses, GetApiV1PatientsByPatientIdMedicationsData, GetApiV1PatientsByPatientIdMedicationsErrors, GetApiV1PatientsByPatientIdMedicationsResponses, GetApiV1PatientsByPatientIdMonitoringInfoData, GetApiV1PatientsByPatientIdMonitoringInfoErrors, GetApiV1PatientsByPatientIdMonitoringInfoResponses, GetApiV1PatientsByPatientIdPpgsData, GetApiV1PatientsByPatientIdPpgsErrors, GetApiV1PatientsByPatientIdPpgsResponses, GetApiV1PatientsByPatientIdQuestionnairesData, GetApiV1PatientsByPatientIdQuestionnairesErrors, GetApiV1PatientsByPatientIdQuestionnairesResponses, GetApiV1PatientsByPatientIdResponses, GetApiV1PatientsByPatientIdSymptomsData, GetApiV1PatientsByPatientIdSymptomsErrors, GetApiV1PatientsByPatientIdSymptomsResponses, GetApiV1PatientsByPatientIdThresholdsData, GetApiV1PatientsByPatientIdThresholdsErrors, GetApiV1PatientsByPatientIdThresholdsResponses, GetApiV1PatientsCountsData, GetApiV1PatientsCountsResponses, GetApiV1PatientsData, GetApiV1PatientsErrors, GetApiV1PatientsMinimalData, GetApiV1PatientsMinimalErrors, GetApiV1PatientsMinimalResponses, GetApiV1PatientsResponses, GetApiV1PhysiciansData, GetApiV1PhysiciansErrors, GetApiV1PhysiciansResponses, GetApiV1PoliciesByUuidData, GetApiV1PoliciesByUuidErrors, GetApiV1PoliciesByUuidResponses, GetApiV1PoliciesData, GetApiV1PoliciesErrors, GetApiV1PoliciesPermissionsMetadataData, GetApiV1PoliciesPermissionsMetadataErrors, GetApiV1PoliciesPermissionsMetadataResponses, GetApiV1PoliciesResponses, GetApiV1PpgByUuidData, GetApiV1PpgByUuidErrors, GetApiV1PpgByUuidResponses, GetApiV1PpgData, GetApiV1PpgErrors, GetApiV1PpgLastData, GetApiV1PpgLastErrors, GetApiV1PpgLastResponses, GetApiV1PpgResponses, GetApiV1PushNotificationsLogData, GetApiV1PushNotificationsLogErrors, GetApiV1PushNotificationsLogResponses, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageData, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageErrors, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageResponses, GetApiV1QuestionnairesData, GetApiV1QuestionnairesErrors, GetApiV1QuestionnairesResponses, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdData, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdErrors, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdResponses, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallData, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallErrors, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallResponses, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdData, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdErrors, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdResponses, GetApiV1RegistrationPasswordFormByFormTypeByLanguageData, GetApiV1RegistrationPasswordFormByFormTypeByLanguageErrors, GetApiV1RegistrationPasswordFormByFormTypeByLanguageResponses, GetApiV1SchedulesCheckByPatientIdData, GetApiV1SchedulesCheckByPatientIdErrors, GetApiV1SchedulesCheckByPatientIdResponses, GetApiV1SchedulesComplianceByPatientIdData, GetApiV1SchedulesComplianceByPatientIdErrors, GetApiV1SchedulesComplianceByPatientIdResponses, GetApiV1SchedulesData, GetApiV1SchedulesErrors, GetApiV1SchedulesNextMeasurementByPatientIdData, GetApiV1SchedulesNextMeasurementByPatientIdErrors, GetApiV1SchedulesNextMeasurementByPatientIdResponses, GetApiV1SchedulesResponses, GetApiV1ServiceAccountsData, GetApiV1ServiceAccountsErrors, GetApiV1ServiceAccountsMeData, GetApiV1ServiceAccountsMeErrors, GetApiV1ServiceAccountsMeResponses, GetApiV1ServiceAccountsResponses, GetApiV1ServiceAccountsSelfData, GetApiV1ServiceAccountsSelfErrors, GetApiV1ServiceAccountsSelfResponses, GetApiV1StudyTextAboutByTextByLanguageData, GetApiV1StudyTextAboutByTextByLanguageErrors, GetApiV1StudyTextAboutByTextByLanguageResponses, GetApiV1StudyTextByMonitoringTypeByTextLanguageData, GetApiV1StudyTextByMonitoringTypeByTextLanguageErrors, GetApiV1StudyTextByMonitoringTypeByTextLanguageResponses, GetApiV1StudyTextData, GetApiV1StudyTextErrors, GetApiV1StudyTextResponses, GetApiV1SymptomsData, GetApiV1SymptomsErrors, GetApiV1SymptomsLastData, GetApiV1SymptomsLastErrors, GetApiV1SymptomsLastResponses, GetApiV1SymptomsListData, GetApiV1SymptomsListErrors, GetApiV1SymptomsListResponses, GetApiV1SymptomsResponses, GetApiV1TasksApiResultByTaskIdData, GetApiV1TasksApiResultByTaskIdErrors, GetApiV1TasksApiResultByTaskIdResponses, GetApiV1TasksApiStatusByTaskIdData, GetApiV1TasksApiStatusByTaskIdErrors, GetApiV1TasksApiStatusByTaskIdResponses, GetApiV1TasksApiTaskIdsData, GetApiV1TasksApiTaskIdsErrors, GetApiV1TasksApiTaskIdsResponses, GetApiV1TasksWorkerListQuicklookTasksData, GetApiV1TasksWorkerListQuicklookTasksErrors, GetApiV1TasksWorkerListQuicklookTasksResponses, GetApiV1TasksWorkerListTasksData, GetApiV1TasksWorkerListTasksErrors, GetApiV1TasksWorkerListTasksResponses, GetApiV1TasksWorkerQuicklookByTaskIdData, GetApiV1TasksWorkerQuicklookByTaskIdErrors, GetApiV1TasksWorkerQuicklookByTaskIdJsonData, GetApiV1TasksWorkerQuicklookByTaskIdJsonErrors, GetApiV1TasksWorkerQuicklookByTaskIdJsonResponses, GetApiV1TasksWorkerQuicklookByTaskIdPdfData, GetApiV1TasksWorkerQuicklookByTaskIdPdfErrors, GetApiV1TasksWorkerQuicklookByTaskIdPdfResponses, GetApiV1TasksWorkerQuicklookByTaskIdResponses, GetApiV1TasksWorkerQuicklookShareByTaskIdData, GetApiV1TasksWorkerQuicklookShareByTaskIdErrors, GetApiV1TasksWorkerQuicklookShareByTaskIdResponses, GetApiV1TasksWorkerQuicklookSharedByTaskIdData, GetApiV1TasksWorkerQuicklookSharedByTaskIdErrors, GetApiV1TasksWorkerQuicklookSharedByTaskIdResponses, GetApiV1TasksWorkerResultByTaskIdData, GetApiV1TasksWorkerResultByTaskIdErrors, GetApiV1TasksWorkerResultByTaskIdResponses, GetApiV1TasksWorkerStatusByTaskIdData, GetApiV1TasksWorkerStatusByTaskIdErrors, GetApiV1TasksWorkerStatusByTaskIdResponses, GetApiV1ThresholdsData, GetApiV1ThresholdsDefaultData, GetApiV1ThresholdsDefaultErrors, GetApiV1ThresholdsDefaultResponses, GetApiV1ThresholdsErrors, GetApiV1ThresholdsResponses, GetApiV1UsersByUuidDeleteImpactData, GetApiV1UsersByUuidDeleteImpactErrors, GetApiV1UsersByUuidDeleteImpactResponses, GetApiV1UsersData, GetApiV1UsersErrors, GetApiV1UsersMeData, GetApiV1UsersMeErrors, GetApiV1UsersMeResponses, GetApiV1UsersMonitoringUsersData, GetApiV1UsersMonitoringUsersErrors, GetApiV1UsersMonitoringUsersResponses, GetApiV1UsersPhysiciansData, GetApiV1UsersPhysiciansErrors, GetApiV1UsersPhysiciansResponses, GetApiV1UsersResponses, GetApiV1UtilsCountriesData, GetApiV1UtilsCountriesErrors, GetApiV1UtilsCountriesResponses, GetApiV1UtilsErrorCodesByLanguageData, GetApiV1UtilsErrorCodesByLanguageErrors, GetApiV1UtilsErrorCodesByLanguageResponses, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageData, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageErrors, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageResponses, GetApiV2QuestionnairesShouldFillByPatientIdData, GetApiV2QuestionnairesShouldFillByPatientIdErrors, GetApiV2QuestionnairesShouldFillByPatientIdResponses, PostApiV1AiFeedbackData, PostApiV1AiFeedbackErrors, PostApiV1AiFeedbackResponses, PostApiV1AlertsData, PostApiV1AlertsErrors, PostApiV1AlertsResponses, PostApiV1AlertsValidateByUuidData, PostApiV1AlertsValidateByUuidErrors, PostApiV1AlertsValidateByUuidResponses, PostApiV1AuthFreshLoginData, PostApiV1AuthFreshLoginErrors, PostApiV1AuthFreshLoginResponses, PostApiV1AuthLoginData, PostApiV1AuthLoginErrors, PostApiV1AuthLoginResponses, PostApiV1AuthServiceLoginData, PostApiV1AuthServiceLoginErrors, PostApiV1AuthServiceLoginResponses, PostApiV1AuthTokenLoginData, PostApiV1AuthTokenLoginErrors, PostApiV1AuthTokenLoginResponses, PostApiV1AuxiliaryAccelerometerData, PostApiV1AuxiliaryAccelerometerErrors, PostApiV1AuxiliaryAccelerometerResponses, PostApiV1AuxiliaryAlivecorAvgBeatData, PostApiV1AuxiliaryAlivecorAvgBeatErrors, PostApiV1AuxiliaryAlivecorAvgBeatResponses, PostApiV1AuxiliaryGyrometerData, PostApiV1AuxiliaryGyrometerErrors, PostApiV1AuxiliaryGyrometerResponses, PostApiV1BillingUsersData, PostApiV1BillingUsersErrors, PostApiV1BillingUsersResponses, PostApiV1ClinicalStudiesAdminProcedureData, PostApiV1ClinicalStudiesAdminProcedureErrors, PostApiV1ClinicalStudiesAdminProcedureResponses, PostApiV1ClinicalStudiesAssociationComputedData, PostApiV1ClinicalStudiesAssociationComputedErrors, PostApiV1ClinicalStudiesAssociationComputedResponses, PostApiV1ClinicalStudiesAssociationDerivedData, PostApiV1ClinicalStudiesAssociationDerivedErrors, PostApiV1ClinicalStudiesAssociationDerivedResponses, PostApiV1ClinicalStudiesAssociationDiagnosesData, PostApiV1ClinicalStudiesAssociationDiagnosesErrors, PostApiV1ClinicalStudiesAssociationDiagnosesResponses, PostApiV1ClinicalStudiesAssociationEventsData, PostApiV1ClinicalStudiesAssociationEventsErrors, PostApiV1ClinicalStudiesAssociationEventsResponses, PostApiV1ClinicalStudiesAssociationMedicalDataData, PostApiV1ClinicalStudiesAssociationMedicalDataErrors, PostApiV1ClinicalStudiesAssociationMedicalDataResponses, PostApiV1ClinicalStudiesAssociationMedicalReportsData, PostApiV1ClinicalStudiesAssociationMedicalReportsErrors, PostApiV1ClinicalStudiesAssociationMedicalReportsResponses, PostApiV1ClinicalStudiesAssociationMedicationsData, PostApiV1ClinicalStudiesAssociationMedicationsErrors, PostApiV1ClinicalStudiesAssociationMedicationsResponses, PostApiV1ClinicalStudiesAssociationPpgsData, PostApiV1ClinicalStudiesAssociationPpgsErrors, PostApiV1ClinicalStudiesAssociationPpgsResponses, PostApiV1ClinicalStudiesAssociationQuestionnairesData, PostApiV1ClinicalStudiesAssociationQuestionnairesErrors, PostApiV1ClinicalStudiesAssociationQuestionnairesResponses, PostApiV1ClinicalStudiesAssociationSymptomsData, PostApiV1ClinicalStudiesAssociationSymptomsErrors, PostApiV1ClinicalStudiesAssociationSymptomsResponses, PostApiV1ClinicalStudiesEnrollData, PostApiV1ClinicalStudiesEnrollErrors, PostApiV1ClinicalStudiesEnrollResponses, PostApiV1ClinicalStudiesStudyVisitData, PostApiV1ClinicalStudiesStudyVisitErrors, PostApiV1ClinicalStudiesStudyVisitResponses, PostApiV1ClinicsData, PostApiV1ClinicsErrors, PostApiV1ClinicsResponses, PostApiV1ComputedData, PostApiV1ComputedErrors, PostApiV1ComputedResponses, PostApiV1DerivedBerryData, PostApiV1DerivedBerryErrors, PostApiV1DerivedBerryResponses, PostApiV1DerivedViatomData, PostApiV1DerivedViatomErrors, PostApiV1DerivedViatomResponses, PostApiV1DiagnosesBulkData, PostApiV1DiagnosesBulkErrors, PostApiV1DiagnosesBulkResponses, PostApiV1DiagnosesData, PostApiV1DiagnosesErrors, PostApiV1DiagnosesResponses, PostApiV1EcgAlivecorData, PostApiV1EcgAlivecorErrors, PostApiV1EcgAlivecorResponses, PostApiV1EcgDerivedAlivecorData, PostApiV1EcgDerivedAlivecorErrors, PostApiV1EcgDerivedAlivecorResponses, PostApiV1EcgGenericData, PostApiV1EcgGenericErrors, PostApiV1EcgGenericResponses, PostApiV1EventsData, PostApiV1EventsErrors, PostApiV1EventsResponses, PostApiV1HfComorbiditiesData, PostApiV1HfComorbiditiesErrors, PostApiV1HfComorbiditiesResponses, PostApiV1HfDataData, PostApiV1HfDataErrors, PostApiV1HfDataResponses, PostApiV1HfExamsEchoData, PostApiV1HfExamsEchoErrors, PostApiV1HfExamsEchoResponses, PostApiV1HfExamsLhcData, PostApiV1HfExamsLhcErrors, PostApiV1HfExamsLhcResponses, PostApiV1HfExamsRhcData, PostApiV1HfExamsRhcErrors, PostApiV1HfExamsRhcResponses, PostApiV1HfSymptomsData, PostApiV1HfSymptomsErrors, PostApiV1HfSymptomsResponses, PostApiV1LimitersData, PostApiV1LimitersErrors, PostApiV1LimitersResponses, PostApiV1MedicaldataBulkData, PostApiV1MedicaldataBulkErrors, PostApiV1MedicaldataBulkResponses, PostApiV1MedicaldataData, PostApiV1MedicaldataErrors, PostApiV1MedicaldataResponses, PostApiV1MedicalReportsByUuidExtractionExtractRegionData, PostApiV1MedicalReportsByUuidExtractionExtractRegionErrors, PostApiV1MedicalReportsByUuidExtractionExtractRegionResponses, PostApiV1MedicalReportsByUuidExtractionIngestData, PostApiV1MedicalReportsByUuidExtractionIngestErrors, PostApiV1MedicalReportsByUuidExtractionIngestResponses, PostApiV1MedicalReportsByUuidExtractionRejectData, PostApiV1MedicalReportsByUuidExtractionRejectErrors, PostApiV1MedicalReportsByUuidExtractionRejectResponses, PostApiV1MedicalReportsByUuidExtractionRetryData, PostApiV1MedicalReportsByUuidExtractionRetryErrors, PostApiV1MedicalReportsByUuidExtractionRetryResponses, PostApiV1MedicalReportsData, PostApiV1MedicalReportsErrors, PostApiV1MedicalReportsMultifileData, PostApiV1MedicalReportsMultifileErrors, PostApiV1MedicalReportsMultifileResponses, PostApiV1MedicalReportsResponses, PostApiV1MedicationsBulkData, PostApiV1MedicationsBulkErrors, PostApiV1MedicationsBulkResponses, PostApiV1MedicationsData, PostApiV1MedicationsErrors, PostApiV1MedicationsResponses, PostApiV1MessagingData, PostApiV1MessagingErrors, PostApiV1MessagingResponses, PostApiV1MfaAdminResetByUuidData, PostApiV1MfaAdminResetByUuidErrors, PostApiV1MfaAdminResetByUuidResponses, PostApiV1MfaBackupCodesRegenerateData, PostApiV1MfaBackupCodesRegenerateResponses, PostApiV1MfaChallengeVerifyData, PostApiV1MfaChallengeVerifyErrors, PostApiV1MfaChallengeVerifyResponses, PostApiV1MfaChallengeWebauthnOptionsData, PostApiV1MfaChallengeWebauthnOptionsErrors, PostApiV1MfaChallengeWebauthnOptionsResponses, PostApiV1MfaChallengeWebauthnVerifyData, PostApiV1MfaChallengeWebauthnVerifyErrors, PostApiV1MfaChallengeWebauthnVerifyResponses, PostApiV1MfaEnrollTotpConfirmData, PostApiV1MfaEnrollTotpConfirmErrors, PostApiV1MfaEnrollTotpConfirmResponses, PostApiV1MfaEnrollTotpStartData, PostApiV1MfaEnrollTotpStartErrors, PostApiV1MfaEnrollTotpStartResponses, PostApiV1MfaEnrollWebauthnOptionsData, PostApiV1MfaEnrollWebauthnOptionsErrors, PostApiV1MfaEnrollWebauthnOptionsResponses, PostApiV1MfaEnrollWebauthnVerifyData, PostApiV1MfaEnrollWebauthnVerifyErrors, PostApiV1MfaEnrollWebauthnVerifyResponses, PostApiV1MonitoringSettingsMonitoringData, PostApiV1MonitoringSettingsMonitoringErrors, PostApiV1MonitoringSettingsMonitoringResponses, PostApiV1MonitoringSettingsQuestionnairesData, PostApiV1MonitoringSettingsQuestionnairesErrors, PostApiV1MonitoringSettingsQuestionnairesResponses, PostApiV1PatientsByPatientIdAiOutputsData, PostApiV1PatientsByPatientIdAiOutputsErrors, PostApiV1PatientsByPatientIdAiOutputsResponses, PostApiV1PatientsByPatientIdUserData, PostApiV1PatientsByPatientIdUserErrors, PostApiV1PatientsByPatientIdUserResponses, PostApiV1PatientsData, PostApiV1PatientsErrors, PostApiV1PatientsPatientAndUserData, PostApiV1PatientsPatientAndUserErrors, PostApiV1PatientsPatientAndUserResponses, PostApiV1PatientsResponses, PostApiV1PhysiciansData, PostApiV1PhysiciansErrors, PostApiV1PhysiciansResponses, PostApiV1PpgBerryData, PostApiV1PpgBerryErrors, PostApiV1PpgBerryResponses, PostApiV1PpgGenericData, PostApiV1PpgGenericErrors, PostApiV1PpgGenericResponses, PostApiV1PpgMobileData, PostApiV1PpgMobileErrors, PostApiV1PpgMobileResponses, PostApiV1PpgSamsungData, PostApiV1PpgSamsungErrors, PostApiV1PpgSamsungResponses, PostApiV1PpgSmartcareData, PostApiV1PpgSmartcareErrors, PostApiV1PpgSmartcareResponses, PostApiV1PpgViatomData, PostApiV1PpgViatomErrors, PostApiV1PpgViatomResponses, PostApiV1PushNotificationsSendData, PostApiV1PushNotificationsSendErrors, PostApiV1PushNotificationsSendResponses, PostApiV1PushNotificationsSendTemplatedData, PostApiV1PushNotificationsSendTemplatedErrors, PostApiV1PushNotificationsSendTemplatedResponses, PostApiV1PushNotificationsSendToPatientData, PostApiV1PushNotificationsSendToPatientErrors, PostApiV1PushNotificationsSendToPatientResponses, PostApiV1PushTokensRegisterByUuidData, PostApiV1PushTokensRegisterByUuidErrors, PostApiV1PushTokensRegisterByUuidResponses, PostApiV1PushTokensRegisterData, PostApiV1PushTokensRegisterErrors, PostApiV1PushTokensRegisterResponses, PostApiV1QuestionnairesData, PostApiV1QuestionnairesErrors, PostApiV1QuestionnairesResponses, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdData, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdErrors, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdResponses, PostApiV1RegistrationPreregisterPatientData, PostApiV1RegistrationPreregisterPatientErrors, PostApiV1RegistrationPreregisterPatientResponses, PostApiV1RegistrationPreregisterPhysicianData, PostApiV1RegistrationPreregisterPhysicianErrors, PostApiV1RegistrationPreregisterPhysicianResponses, PostApiV1SchedulesData, PostApiV1SchedulesErrors, PostApiV1SchedulesResponses, PostApiV1ServiceAccountsByServiceAccountUuidKeysData, PostApiV1ServiceAccountsByServiceAccountUuidKeysErrors, PostApiV1ServiceAccountsByServiceAccountUuidKeysResponses, PostApiV1ServiceAccountsData, PostApiV1ServiceAccountsErrors, PostApiV1ServiceAccountsResponses, PostApiV1ServiceAccountsSelfData, PostApiV1ServiceAccountsSelfErrors, PostApiV1ServiceAccountsSelfResponses, PostApiV1StudyTextData, PostApiV1StudyTextErrors, PostApiV1StudyTextResponses, PostApiV1SymptomsData, PostApiV1SymptomsErrors, PostApiV1SymptomsResponses, PostApiV1TasksWorkerQuicklookPatientData, PostApiV1TasksWorkerQuicklookPatientErrors, PostApiV1TasksWorkerQuicklookPatientResponses, PostApiV1TasksWorkerQuicklookPpgData, PostApiV1TasksWorkerQuicklookPpgErrors, PostApiV1TasksWorkerQuicklookPpgResponses, PostApiV1TasksWorkerSubmitPatientData, PostApiV1TasksWorkerSubmitPatientErrors, PostApiV1TasksWorkerSubmitPatientResponses, PostApiV1TasksWorkerSubmitPpgData, PostApiV1TasksWorkerSubmitPpgErrors, PostApiV1TasksWorkerSubmitPpgResponses, PostApiV1TasksWorkflowBuildData, PostApiV1TasksWorkflowBuildErrors, PostApiV1TasksWorkflowBuildResponses, PostApiV1TasksWorkflowSubmitData, PostApiV1TasksWorkflowSubmitErrors, PostApiV1TasksWorkflowSubmitResponses, PostApiV1ThresholdsData, PostApiV1ThresholdsErrors, PostApiV1ThresholdsResponses, PostApiV1UsersData, PostApiV1UsersErrors, PostApiV1UsersResponses, PutApiV1AlertsByPatientIdWaitingRoomData, PutApiV1AlertsByPatientIdWaitingRoomErrors, PutApiV1AlertsByPatientIdWaitingRoomResponses, PutApiV1AlertsByUuidData, PutApiV1AlertsByUuidErrors, PutApiV1AlertsByUuidResponses, PutApiV1AlertsMarkAllSeenByPatientIdData, PutApiV1AlertsMarkAllSeenByPatientIdErrors, PutApiV1AlertsMarkAllSeenByPatientIdResponses, PutApiV1AlertsMarkSeenByUuidData, PutApiV1AlertsMarkSeenByUuidErrors, PutApiV1AlertsMarkSeenByUuidResponses, PutApiV1AuditData, PutApiV1AuditErrors, PutApiV1AuditResponses, PutApiV1AuthRequestTokenLoginData, PutApiV1AuthRequestTokenLoginErrors, PutApiV1AuthRequestTokenLoginResponses, PutApiV1BillingUsersByUserUuidCreditsData, PutApiV1BillingUsersByUserUuidCreditsErrors, PutApiV1BillingUsersByUserUuidCreditsResponses, PutApiV1ClinicalStudiesAdminProcedureByUuidData, PutApiV1ClinicalStudiesAdminProcedureByUuidErrors, PutApiV1ClinicalStudiesAdminProcedureByUuidResponses, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidErrors, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponses, PutApiV1ClinicalStudiesEnrollmentByUuidData, PutApiV1ClinicalStudiesEnrollmentByUuidErrors, PutApiV1ClinicalStudiesEnrollmentByUuidResponses, PutApiV1ClinicalStudiesStudyVisitByUuidData, PutApiV1ClinicalStudiesStudyVisitByUuidErrors, PutApiV1ClinicalStudiesStudyVisitByUuidResponses, PutApiV1ClinicsByUuidData, PutApiV1ClinicsByUuidErrors, PutApiV1ClinicsByUuidResponses, PutApiV1ComputedByUuidData, PutApiV1ComputedByUuidErrors, PutApiV1ComputedByUuidResponses, PutApiV1DerivedByUuidData, PutApiV1DerivedByUuidErrors, PutApiV1DerivedByUuidResponses, PutApiV1DerivedPpgByPpgUuidData, PutApiV1DerivedPpgByPpgUuidErrors, PutApiV1DerivedPpgByPpgUuidResponses, PutApiV1DiagnosesByUuidData, PutApiV1DiagnosesByUuidErrors, PutApiV1DiagnosesByUuidResponses, PutApiV1EcgByUuidData, PutApiV1EcgByUuidErrors, PutApiV1EcgByUuidResponses, PutApiV1EcgDerivedByUuidData, PutApiV1EcgDerivedByUuidErrors, PutApiV1EcgDerivedByUuidResponses, PutApiV1EcgDerivedEcgByEcgUuidData, PutApiV1EcgDerivedEcgByEcgUuidErrors, PutApiV1EcgDerivedEcgByEcgUuidResponses, PutApiV1EventsByUuidData, PutApiV1EventsByUuidErrors, PutApiV1EventsByUuidResponses, PutApiV1LimitersByUuidData, PutApiV1LimitersByUuidErrors, PutApiV1LimitersByUuidResponses, PutApiV1MedicaldataByUuidData, PutApiV1MedicaldataByUuidErrors, PutApiV1MedicaldataByUuidResponses, PutApiV1MedicalReportsByUuidData, PutApiV1MedicalReportsByUuidErrors, PutApiV1MedicalReportsByUuidExtractionData, PutApiV1MedicalReportsByUuidExtractionErrors, PutApiV1MedicalReportsByUuidExtractionResponses, PutApiV1MedicalReportsByUuidResponses, PutApiV1MedicationsByUuidData, PutApiV1MedicationsByUuidErrors, PutApiV1MedicationsByUuidResponses, PutApiV1MedicationsChangeByUuidData, PutApiV1MedicationsChangeByUuidErrors, PutApiV1MedicationsChangeByUuidResponses, PutApiV1MessagingByUuidData, PutApiV1MessagingByUuidErrors, PutApiV1MessagingByUuidResponses, PutApiV1MonitoringSettingsMonitoringByUuidData, PutApiV1MonitoringSettingsMonitoringByUuidErrors, PutApiV1MonitoringSettingsMonitoringByUuidResponses, PutApiV1MonitoringSettingsQuestionnairesByUuidData, PutApiV1MonitoringSettingsQuestionnairesByUuidErrors, PutApiV1MonitoringSettingsQuestionnairesByUuidResponses, PutApiV1PatientsByPatientIdApproveConsentPaperData, PutApiV1PatientsByPatientIdApproveConsentPaperErrors, PutApiV1PatientsByPatientIdApproveConsentPaperResponses, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringData, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringErrors, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringResponses, PutApiV1PatientsByPatientIdData, PutApiV1PatientsByPatientIdErrors, PutApiV1PatientsByPatientIdResponses, PutApiV1PatientsByPatientIdRevokeConsentPaperData, PutApiV1PatientsByPatientIdRevokeConsentPaperErrors, PutApiV1PatientsByPatientIdRevokeConsentPaperResponses, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringData, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringErrors, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringResponses, PutApiV1PhysiciansByUuidData, PutApiV1PhysiciansByUuidErrors, PutApiV1PhysiciansByUuidResponses, PutApiV1PoliciesByUuidData, PutApiV1PoliciesByUuidErrors, PutApiV1PoliciesByUuidResponses, PutApiV1PpgByUuidData, PutApiV1PpgByUuidErrors, PutApiV1PpgByUuidResponses, PutApiV1QuestionnairesByUuidData, PutApiV1QuestionnairesByUuidErrors, PutApiV1QuestionnairesByUuidResponses, PutApiV1RegistrationFinishPatientData, PutApiV1RegistrationFinishPatientErrors, PutApiV1RegistrationFinishPatientResponses, PutApiV1RegistrationFinishPhysicianData, PutApiV1RegistrationFinishPhysicianErrors, PutApiV1RegistrationFinishPhysicianResponses, PutApiV1SchedulesByUuidData, PutApiV1SchedulesByUuidErrors, PutApiV1SchedulesByUuidResponses, PutApiV1ServiceAccountsByServiceAccountUuidOwnerData, PutApiV1ServiceAccountsByServiceAccountUuidOwnerErrors, PutApiV1ServiceAccountsByServiceAccountUuidOwnerResponses, PutApiV1ServiceAccountsByServiceAccountUuidStatusData, PutApiV1ServiceAccountsByServiceAccountUuidStatusErrors, PutApiV1ServiceAccountsByServiceAccountUuidStatusResponses, PutApiV1StudyTextByUuidData, PutApiV1StudyTextByUuidErrors, PutApiV1StudyTextByUuidResponses, PutApiV1SymptomsByUuidData, PutApiV1SymptomsByUuidErrors, PutApiV1SymptomsByUuidResponses, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdData, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdErrors, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdResponses, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdData, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdErrors, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdResponses, PutApiV1ThresholdsByUuidData, PutApiV1ThresholdsByUuidErrors, PutApiV1ThresholdsByUuidResponses, PutApiV1UsersByUuidArchiveData, PutApiV1UsersByUuidArchiveErrors, PutApiV1UsersByUuidArchiveResponses, PutApiV1UsersByUuidData, PutApiV1UsersByUuidErrors, PutApiV1UsersByUuidResponses, PutApiV1UsersByUuidUnarchiveData, PutApiV1UsersByUuidUnarchiveErrors, PutApiV1UsersByUuidUnarchiveResponses, PutApiV1UsersChangePasswordData, PutApiV1UsersChangePasswordErrors, PutApiV1UsersChangePasswordResponses, PutApiV1UsersForgotPasswordData, PutApiV1UsersForgotPasswordErrors, PutApiV1UsersForgotPasswordResponses, PutApiV1UsersResetByUuidData, PutApiV1UsersResetByUuidErrors, PutApiV1UsersResetByUuidResponses, PutApiV1UsersResetPasswordData, PutApiV1UsersResetPasswordErrors, PutApiV1UsersResetPasswordResponses, PutApiV1UsersTemporaryPassByUuidData, PutApiV1UsersTemporaryPassByUuidErrors, PutApiV1UsersTemporaryPassByUuidResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Request Token Login
 *
 * Request a one-time token login link. The token is valid for 5 minutes.
 * Always returns success to prevent email enumeration.
 *
 * <br /> **Rate Limited:** Protected against flooding.  Maximum 1 request per **5 minutes** per email.  Always returns success to prevent email enumeration.
 */
export const apiPutAuthRequestTokenLogin = <ThrowOnError extends boolean = true>(options: Options<PutApiV1AuthRequestTokenLoginData, ThrowOnError>) => (options.client ?? client).put<PutApiV1AuthRequestTokenLoginResponses, PutApiV1AuthRequestTokenLoginErrors, ThrowOnError>({ url: '/api/v1/auth/request-token-login', ...options });

/**
 * Token Login
 *
 * Login with one-time token. This endpoint validates the token from the
 * email link, marks it as used, and issues fresh JWT access and refresh
 * tokens - unless MFA applies to this account, in which case a challenge
 * is returned instead (see `status` field). The access token expires in
 * 15 minutes, and the refresh token is valid for 60 minutes.
 */
export const apiPostAuthTokenLogin = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuthTokenLoginData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuthTokenLoginResponses, PostApiV1AuthTokenLoginErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/token-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 *
 * Login user and authorize. Returns **fresh** access and refresh tokens
 * and sets access/refresh cookies - unless MFA applies to this account,
 * in which case a challenge is returned instead (see `status` field) and
 * the client must complete it via the `/mfa` endpoints before it has
 * tokens. The access token expires in 15 minutes, and the refresh token
 * is valid for 60 minutes.
 *
 * <br /> **Rate Limited:** Protected against brute-force attacks.  Maximum **20 failed attempts**  per **15 minutes**  per username. Exceeding triggers exponential backoff  (starting at 60 seconds,  up to 1 hours).  Successful login resets the counter.
 */
export const apiPostAuthLogin = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuthLoginData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuthLoginResponses, PostApiV1AuthLoginErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Service Login
 *
 * Exchange a service-account API key for a **non-fresh** access token
 * (OAuth2 client-credentials style). The token expires in 15 minutes;
 * re-exchange before expiry. No refresh token and no cookies are issued —
 * header-only clients.
 *
 * **Rate Limited:** **20 failed attempts** per **15 minutes** per API
 * key lock that key out with exponential backoff; a successful exchange
 * resets the counter. A key matching no account is not counted, since the
 * caller's address is attacker-chosen and the key's entropy is what stops
 * guessing.
 */
export const apiPostAuthServiceLogin = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuthServiceLoginData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuthServiceLoginResponses, PostApiV1AuthServiceLoginErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/service-login',
    ...options
});

/**
 * Fresh Login
 *
 * Fresh user login (re-authentication). Returns a **fresh** access token
 * and sets cookies - unless MFA applies, in which case a challenge is
 * returned instead (see `status` field); completing it via `/mfa/
 * challenge/verify` issues a fresh access token only, same as this
 * endpoint would. Unlike the standard `login` endpoint, this never
 * returns a new refresh token. The fresh access token expires in 15
 * minutes.
 *
 * <br /> **Rate Limited:** Protected against brute-force attacks.  Maximum **20 failed attempts**  per **15 minutes**  per username. Exceeding triggers exponential backoff  (starting at 60 seconds,  up to 1 hours).  Successful login resets the counter.
 */
export const apiPostAuthFreshLogin = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuthFreshLoginData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuthFreshLoginResponses, PostApiV1AuthFreshLoginErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/fresh-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh Token
 *
 * Refresh user token and cookies. Returns a **not fresh** access token and a
 * new refresh token. Each refresh token can be used exactly once - after a
 * successful refresh, the previous refresh token is immediately invalidated.
 * Store the returned `refresh_token` and use it for the next refresh call.
 * A refresh counts as a login for the inactivity check and ends a password
 * reset the user asked for, but not one an admin requested.
 * The access token expires in 15 minutes, and the new refresh token is
 * valid for 60 minutes.
 */
export const apiGetAuthRefresh = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AuthRefreshData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuthRefreshResponses, GetApiV1AuthRefreshErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/refresh',
    ...options
});

/**
 * Is Fresh
 *
 * Check whether the access token of the current user is **fresh** or not.
 */
export const apiGetAuthIsFresh = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AuthIsFreshData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuthIsFreshResponses, GetApiV1AuthIsFreshErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/is-fresh',
    ...options
});

/**
 * Logout
 *
 * Logout user. This endpoint un-sets cookies and revokes access and refresh
 * tokens.
 */
export const apiGetAuthLogout = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AuthLogoutData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuthLogoutResponses, GetApiV1AuthLogoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout',
    ...options
});

/**
 * Logout All
 *
 * Logout user from **all** active sessions. This invalidates every access
 * and refresh token issued to this user up to this point, regardless of
 * device or client. Also un-sets cookies for the current session.
 *
 * This works by storing the current timestamp. Any token issued at
 * or before this timestamp will be treated as revoked. The Redis key expires
 * after the refresh token lifetime and is cleaned up automatically.
 */
export const apiGetAuthLogoutAll = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AuthLogoutAllData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuthLogoutAllResponses, GetApiV1AuthLogoutAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/logout-all',
    ...options
});

/**
 * Admin Logout User
 *
 * Admin endpoint to logout a user (or service account) from **all** active
 * sessions by their UUID. This invalidates every access and refresh token
 * issued to the target account up to this point.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiGetAuthAdminLogoutUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1AuthAdminLogoutByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AuthAdminLogoutByUuidResponses, GetApiV1AuthAdminLogoutByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/admin-logout/{uuid}',
    ...options
});

/**
 * Revoke Access Token
 *
 * Revoke access token for the current user.
 */
export const apiDeleteAuthAccessRevoke = <ThrowOnError extends boolean = true>(options?: Options<DeleteApiV1AuthAccessRevokeData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiV1AuthAccessRevokeResponses, DeleteApiV1AuthAccessRevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/access-revoke',
    ...options
});

/**
 * Revoke Refresh Token
 *
 * Revoke refresh token for the current user.
 */
export const apiDeleteAuthRefreshRevoke = <ThrowOnError extends boolean = true>(options?: Options<DeleteApiV1AuthRefreshRevokeData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiV1AuthRefreshRevokeResponses, DeleteApiV1AuthRefreshRevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/refresh-revoke',
    ...options
});

/**
 * Get Me
 *
 * Get the current user. Humans only — the response schemas are
 * human-shaped; service accounts introspect via
 * `GET /service-accounts/me`.
 */
export const apiGetUsersMe = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1UsersMeData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1UsersMeResponses, GetApiV1UsersMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Forgot Password
 *
 * Ask for a password reset for a given email. This puts a user connected to
 * the provided email into a reset, keeping an admin's reset or a deactivation
 * as it is. This endpoint sends a reset mail to
 * the given user's email that includes an URL pointing to the `reset-password`
 * endpoint, including encoded one-time tokens.  The email is sent using API
 * background tasks and this endpoint return a task ID, which then might be
 * inquired for status using the `tasks/api/status/` endpoint. The token
 * expires after 12:00:00 hours.
 */
export const apiPutUsersForgotPassword = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersForgotPasswordData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersForgotPasswordResponses, PutApiV1UsersForgotPasswordErrors, ThrowOnError>({ url: '/api/v1/users/forgot-password', ...options });

/**
 * Reset Password
 *
 * Reset password. To be used after obtaining tokens from the `forgot_password`
 * endpoint.
 */
export const apiPutUsersResetPassword = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersResetPasswordData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersResetPasswordResponses, PutApiV1UsersResetPasswordErrors, ThrowOnError>({
    url: '/api/v1/users/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Change the password of the current user.
 */
export const apiPutUsersChangePassword = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersChangePasswordData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersChangePasswordResponses, PutApiV1UsersChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Users
 *
 * Get the list of all users. For monitoring users querying, returns users with
 * self-visibility only and if the role is managing, will also filter on
 * connected patient ID based on patient visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUsers = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1UsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1UsersResponses, GetApiV1UsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users',
    ...options
});

/**
 * Create User
 *
 * Create a new user. Passwords are validated and must have at least 10
 * characters and contain at least one uppercase letter, one lowercase letter,
 * and one digit. The role's default permissions must be within the ones you
 * hold yourself (`403` otherwise).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostUsers = <ThrowOnError extends boolean = true>(options: Options<PostApiV1UsersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UsersResponses, PostApiV1UsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Physicians
 *
 * Get the list of all users that are in the patient managing role (i.e., their
 * data-visibility access is **managed**). Full-visibility users see all such
 * users; other users see only users whose connected physician is within their
 * visibility scope (assigned physicians, assigned clinics' physicians, or
 * physicians in their regions), i.e. users without a connected physician are
 * not listed for them.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersPhysicians = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1UsersPhysiciansData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1UsersPhysiciansResponses, GetApiV1UsersPhysiciansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/physicians',
    ...options
});

/**
 * Get Monitoring Users
 *
 * Get the list of monitoring users, i.e. users that have access policies
 * with monitoring_active=True and appropriate permissions. Optional query
 * parameters can filter by country (via the countries array) and/or region
 * (integer ID within the given country, requires country). This endpoint
 * cannot be called by a **self-only** user role nor a screening account. It
 * lists the users eligible now, not existing assignments: a physician's
 * current monitoring users are its `assigned_monitoring_users` on
 * `GET /physicians`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersMonitoringUsers = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1UsersMonitoringUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1UsersMonitoringUsersResponses, GetApiV1UsersMonitoringUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/monitoring-users',
    ...options
});

/**
 * Reset User
 *
 * Reset the user given its UUID. Non-admin users (monitoring access) can only
 * reset users with **lower access**, admins can reset **anyone**. Resetting a
 * user updates their status. Optionally, send reset email to the user. This
 * endpoint raises exception when used on protected users.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersResetUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersResetByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersResetByUuidResponses, PutApiV1UsersResetByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/reset/{uuid}',
    ...options
});

/**
 * Set Temporary Password
 *
 * Create a temporary password for a given user by its UUID. Temporary password
 * is created from one adjective, two nouns at random from a predefined
 * dictionary of most used words (localized to the user's preferred language),
 * and random number of digits. Temporary password must be changed by the user
 * (using the `/users/change-password` endpoint, before the expiry). For
 * `token_expiry_timedelta`, we use `timedelta` data type, which`pydantic`
 * (de)serializes to JSON using ISO 8601 standard on durations (see
 * [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersTemporaryPassUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersTemporaryPassByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersTemporaryPassByUuidResponses, PutApiV1UsersTemporaryPassByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/temporary-pass/{uuid}',
    ...options
});

/**
 * Get Delete Impact
 *
 * Report what deleting this user would do, counted per category. `blockers`
 * refuse the `DELETE` outright; `requires_archive_first` refuses it until the
 * account is archived. `423` on protected users, as the `DELETE` answers.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiGetUsersUuidDeleteImpact = <ThrowOnError extends boolean = true>(options: Options<GetApiV1UsersByUuidDeleteImpactData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UsersByUuidDeleteImpactResponses, GetApiV1UsersByUuidDeleteImpactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{uuid}/delete-impact',
    ...options
});

/**
 * Archive User
 *
 * Archive the user given its UUID: the row stays, the account dies. `409`
 * when it is already archived or is a patient user (self-only visibility),
 * who is deleted instead; `403` on the caller's own account, `423` on
 * protected users. Service accounts they own are flagged
 * `owner_deactivated`, the same as deactivating or deleting the owner.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersUuidArchive = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersByUuidArchiveData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersByUuidArchiveResponses, PutApiV1UsersByUuidArchiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{uuid}/archive',
    ...options
});

/**
 * Unarchive User
 *
 * Bring an archived user back as far as an admin password reset; what
 * archival stripped is **not** restored. `409` when the user is not archived.
 * Service accounts they own that were flagged `owner_deactivated` go back
 * to `active`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutUsersUuidUnarchive = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersByUuidUnarchiveData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersByUuidUnarchiveResponses, PutApiV1UsersByUuidUnarchiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{uuid}/unarchive',
    ...options
});

/**
 * Delete User
 *
 * Delete the user given its UUID. `409` with the `delete-impact` report under
 * `data` when rows block the delete, or when a staff user with an attribution
 * trail is not archived yet; `423` on protected users. Service accounts they
 * own are flagged `owner_deactivated` first — `owner_uuid` is `ON DELETE SET
 * NULL`, so an unflagged account would become indistinguishable from an
 * org-owned one while still holding the deleted user's visibility snapshot.
 * Ones already switched off (`not_active`) are retired: they cannot carry
 * the flag, which is a usable status.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteUsersUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1UsersByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1UsersByUuidResponses, DeleteApiV1UsersByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{uuid}',
    ...options
});

/**
 * Update User
 *
 * Update/edit the user given its UUID. Update schema can also append patient
 * ID to the list of managed patient IDs if the updated user is in the
 * **managed** user role. This endpoint raises exception when used on protected
 * users.
 *
 * **Warning**: if username is the same as email in the original user being
 * updated, and update changes one of these, both username and email will be
 * updated accordingly! When both `email` and `username` are part of update
 * body, `username` has preference. Note, that when changing username, the
 * check on uniqueness is performed as usernames must be unique. Setting an
 * `email` another user holds needs admin access, `409` otherwise.
 *
 * **Feature flags**: a payload containing only `feature_flags`, targeting a
 * user with a connected patient, is also allowed for a non-admin caller who
 * has medical-update permission and visibility over that patient. A user
 * without a connected patient (physician, staff) can only have their flags
 * set by an admin, including by themselves. Each flag also carries a
 * `user_editable` bit: a user updating their own flags may only change
 * those currently marked user-editable; changing `user_editable` itself,
 * or a locked flag's value, requires staff-level (monitoring) permission
 * or higher. Sent flag sub-fields that already match the current state
 * are treated as not sent, so round-tripping a previously fetched object
 * back is a no-op rather than a permission error.
 *
 * **Fresh token**: sending `username`, `email`, `role`, or
 * `connected_patient_id` requires a **fresh** access token; any other
 * payload does not.
 */
export const apiPutUsersUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1UsersByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UsersByUuidResponses, PutApiV1UsersByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Totp Enroll Start
 *
 * Begin TOTP enrollment. Generates a new secret and returns its
 * provisioning URI (as text and as a QR code) - the secret is not
 * persisted until confirmed with a valid code via `/enroll/totp/confirm`.
 */
export const apiPostMfaEnrollTotpStart = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaEnrollTotpStartData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaEnrollTotpStartResponses, PostApiV1MfaEnrollTotpStartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/enroll/totp/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Totp Enroll Confirm
 *
 * Confirm TOTP enrollment: verify the first code against the secret from
 * `/enroll/totp/start`, persist the encrypted secret, and generate backup
 * codes on first-ever enrollment (shown once). The voluntary (settings)
 * path may also replace an already-enrolled secret - a mandatory-path
 * submission against an already-enrolled account is instead rejected by
 * `_resolve_enrolling_user` before this function is ever reached. If this
 * completes a login-time mandatory enrollment, also mints tokens and
 * consumes the enrollment challenge.
 */
export const apiPostMfaEnrollTotpConfirm = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaEnrollTotpConfirmData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaEnrollTotpConfirmResponses, PostApiV1MfaEnrollTotpConfirmErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/enroll/totp/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate Backup Codes
 *
 * Regenerate backup codes. Invalidates all previous codes. Requires a
 * fresh token, same as other sensitive account-security operations.
 * Requires an already-enrolled primary method (TOTP or passkey) - a
 * login challenge only ever offers `backup_code` alongside one of those
 * (see `enrolled_methods`), so codes issued without one could never
 * actually be used to complete a login.
 */
export const apiPostMfaBackupCodesRegenerate = <ThrowOnError extends boolean = true>(options?: Options<PostApiV1MfaBackupCodesRegenerateData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1MfaBackupCodesRegenerateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/backup-codes/regenerate',
    ...options
});

/**
 * Verify Challenge
 *
 * Verify an MFA code against a login-time challenge and, on success, mint
 * tokens. Rate-limited per challenge (`MFA_MAX_VERIFY_ATTEMPTS`); once
 * exhausted the challenge is discarded and the client must restart from
 * `/auth/login`.
 */
export const apiPostMfaChallengeVerify = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaChallengeVerifyData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaChallengeVerifyResponses, PostApiV1MfaChallengeVerifyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/challenge/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webauthn Enroll Options
 */
export const apiPostMfaEnrollWebauthnOptions = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaEnrollWebauthnOptionsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaEnrollWebauthnOptionsResponses, PostApiV1MfaEnrollWebauthnOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/enroll/webauthn/options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webauthn Enroll Verify
 */
export const apiPostMfaEnrollWebauthnVerify = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaEnrollWebauthnVerifyData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaEnrollWebauthnVerifyResponses, PostApiV1MfaEnrollWebauthnVerifyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/enroll/webauthn/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webauthn Challenge Options
 */
export const apiPostMfaChallengeWebauthnOptions = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaChallengeWebauthnOptionsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaChallengeWebauthnOptionsResponses, PostApiV1MfaChallengeWebauthnOptionsErrors, ThrowOnError>({
    url: '/api/v1/mfa/challenge/webauthn/options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Webauthn Challenge Verify
 */
export const apiPostMfaChallengeWebauthnVerify = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaChallengeWebauthnVerifyData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaChallengeWebauthnVerifyResponses, PostApiV1MfaChallengeWebauthnVerifyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/challenge/webauthn/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mfa Status
 */
export const apiGetMfaStatus = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MfaStatusData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MfaStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/status',
    ...options
});

/**
 * Remove Totp
 */
export const apiDeleteMfaTotp = <ThrowOnError extends boolean = true>(options?: Options<DeleteApiV1MfaTotpData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiV1MfaTotpResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/totp',
    ...options
});

/**
 * Remove Passkey
 */
export const apiDeleteMfaWebauthnCredentialUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MfaWebauthnByCredentialUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MfaWebauthnByCredentialUuidResponses, DeleteApiV1MfaWebauthnByCredentialUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/webauthn/{credential_uuid}',
    ...options
});

/**
 * Admin Reset Mfa
 *
 * Admin recovery path for a user who has lost every MFA method. Clears
 * all enrolled methods (next login will require re-enrollment), clears
 * any active per-user verify lockout (otherwise the freshly-cleared
 * account still can't complete that re-enrollment), and revokes all of
 * the user's existing sessions. Requires a fresh token from the acting
 * admin - this is the single most destructive MFA action in the system,
 * and `@auth_permissions_doc(..., fresh=True)` alone only feeds the
 * generated docs, it doesn't enforce anything.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostMfaAdminResetUuid = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MfaAdminResetByUuidData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MfaAdminResetByUuidResponses, PostApiV1MfaAdminResetByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mfa/admin/reset/{uuid}',
    ...options
});

/**
 * List Service Accounts
 *
 * Admin-only: list every service account with its key metadata.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetServiceAccounts = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ServiceAccountsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ServiceAccountsResponses, GetApiV1ServiceAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts',
    ...options
});

/**
 * Create Service Account
 *
 * Admin-only: create an org- or user-owned service account with custom
 * permission bits and visibility. FORBIDDEN_SERVICE_PERMISSIONS are
 * rejected (422, via the schema's own validator), and bits you do not
 * hold yourself are refused (403). A named owner must be a live human
 * (409): an account handed to a deactivated one would be invisible to
 * the owner-lifecycle hooks.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostServiceAccounts = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ServiceAccountsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ServiceAccountsResponses, PostApiV1ServiceAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Service Account Status
 *
 * Admin-only: set a service account's status. Any status other than
 * `active` kills every outstanding token with the commit and refuses
 * new exchanges: authz re-reads the status on each request. `retired`
 * is terminal (409 on any change out of it); `not_active` is the
 * reversible kill-switch. Clearing `owner_deactivated` with `active`
 * is refused (409) while the owner is still deactivated or archived —
 * the same rule `PUT /owner` applies to a named heir, and refused
 * outright once the owner is deleted — `PUT /owner` is the only way
 * out then. Un-parking a `not_active` account is not refused: it
 * carries no flag to clear. Reviving an account whose bits reach past
 * the caller's own is refused (403) - its keys come back with it.
 * A protected account cannot be retired (423); `not_active` still kills it.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutServiceAccountsServiceAccountUuidStatus = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ServiceAccountsByServiceAccountUuidStatusData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ServiceAccountsByServiceAccountUuidStatusResponses, PutApiV1ServiceAccountsByServiceAccountUuidStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/{service_account_uuid}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Service Account Owner
 *
 * Admin-only: hand a service account to another human, or to nobody
 * (`null`, org-owned). A named owner also clears `owner_deactivated`
 * back to `active`, which is bounded like `/status`: reviving a machine
 * the caller cannot use is refused. Keys and permissions are untouched,
 * so a handover prompted by losing trust in the previous owner has to
 * be paired with `DELETE /service-accounts/keys/{key_uuid}`; bits the
 * new owner does not hold are logged and audited as
 * `exceeds_new_owner`. `retired` accounts still change hands: the
 * status is terminal, the attribution is not.
 *
 * The new owner must be a live human - a machine may not own a machine
 * (404), and a deactivated human would leave the account un-flagged
 * with nobody to review it (409). Naming *yourself* on an account whose
 * bits reach past your own is refused (403): ownership is a key away.
 * A protected account stays org-owned: naming an owner is refused (423),
 * since the owner's deletion would retire it once parked.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutServiceAccountsServiceAccountUuidOwner = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ServiceAccountsByServiceAccountUuidOwnerData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ServiceAccountsByServiceAccountUuidOwnerResponses, PutApiV1ServiceAccountsByServiceAccountUuidOwnerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/{service_account_uuid}/owner',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Own Service Accounts
 *
 * List service accounts owned by the caller, with their key metadata.
 * Needs no permission bits: for a non-admin owner this is the only
 * source of a `key_uuid`, and losing `CREATE_SERVICE_ACCOUNTS` must
 * not cost the ability to revoke a key already issued.
 */
export const apiGetServiceAccountsSelf = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ServiceAccountsSelfData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ServiceAccountsSelfResponses, GetApiV1ServiceAccountsSelfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/self',
    ...options
});

/**
 * Create Own Service Account
 *
 * Self-service create: owner is always the caller. Granted permissions
 * are the service template intersected with the caller's own resolved
 * bits (an account can never exceed its creator); visibility is copied
 * (snapshot, not live-linked) from the caller's policy at creation time.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Create Service Accounts (53)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostServiceAccountsSelf = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ServiceAccountsSelfData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ServiceAccountsSelfResponses, PostApiV1ServiceAccountsSelfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/self',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Service Account Me
 *
 * Identity of the calling service account — the machine-side
 * counterpart of `GET /users/me`, which serves human-shaped schemas
 * and so rejects service tokens. Requires no permission bits.
 */
export const apiGetServiceAccountsMe = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ServiceAccountsMeData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ServiceAccountsMeResponses, GetApiV1ServiceAccountsMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/me',
    ...options
});

/**
 * Issue Api Key
 *
 * Issue a new API key (admin, or an owner who still holds
 * `CREATE_SERVICE_ACCOUNTS`). On **both** arms the caller must hold
 * every bit the account holds (403): the key is a login as that account,
 * so minting one for a wider account is the grant `POST
 * /service-accounts/` refuses, taken from a row instead of a payload.
 * Bounding the admin arm alone left the refusal four calls away — mint a
 * user at your own level, grant it `CREATE_SERVICE_ACCOUNTS`, hand the
 * account to it, issue the key as it — so an owner narrower than the
 * account it owns can no longer rotate its keys; an admin who does hold
 * the bits still can.
 * Rejects a 3rd active key (409) — revoke
 * one first. Plaintext is returned exactly once, here. An account in
 * any status but `active` is refused (409) — `owner_deactivated`
 * included: the flag keeps existing keys working, it does not license a
 * new 365-day one behind an owner who is gone.
 */
export const apiPostServiceAccountsServiceAccountUuidKeys = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ServiceAccountsByServiceAccountUuidKeysData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ServiceAccountsByServiceAccountUuidKeysResponses, PostApiV1ServiceAccountsByServiceAccountUuidKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/{service_account_uuid}/keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Api Key
 *
 * Revoke a key (admin or the account's owner) and kill the outstanding
 * sessions minted from it. Scoped to this key, so retiring one half of
 * an overlap rotation leaves the other's tokens working; use
 * `PUT /{uuid}/status` to kill an account outright. Idempotent.
 *
 * Needs no `CREATE_SERVICE_ACCOUNTS`, unlike issuance: losing the bit
 * must not cost you the ability to kill a key already issued.
 */
export const apiDeleteServiceAccountsKeysKeyUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ServiceAccountsKeysByKeyUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ServiceAccountsKeysByKeyUuidResponses, DeleteApiV1ServiceAccountsKeysByKeyUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/service-accounts/keys/{key_uuid}',
    ...options
});

/**
 * Register Push Token Self
 *
 * Register push notification token for current user.
 */
export const apiPostPushTokensRegister = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PushTokensRegisterData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PushTokensRegisterResponses, PostApiV1PushTokensRegisterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-tokens/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unregister Push Token Self
 *
 * Unregister push notification token for current user.
 */
export const apiDeletePushTokensUnregisterToken = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1PushTokensUnregisterByTokenData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1PushTokensUnregisterByTokenResponses, DeleteApiV1PushTokensUnregisterByTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-tokens/unregister/{token}',
    ...options
});

/**
 * Register Push Token Admin
 *
 * Register push notification token for specified user (admin only).
 */
export const apiPostPushTokensRegisterUuid = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PushTokensRegisterByUuidData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PushTokensRegisterByUuidResponses, PostApiV1PushTokensRegisterByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-tokens/register/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unregister Push Token Admin
 *
 * Unregister push notification token for specified user (admin only).
 * Validates that the token belongs to the specified user.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeletePushTokensUnregisterUuidToken = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1PushTokensUnregisterByUuidByTokenData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1PushTokensUnregisterByUuidByTokenResponses, DeleteApiV1PushTokensUnregisterByUuidByTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-tokens/unregister/{uuid}/{token}',
    ...options
});

/**
 * Get Permissions Metadata
 *
 * Get permission bits metadata for UI rendering.
 *
 * Returns permission definitions grouped by category.
 * Categories and descriptions are derived from enum names.
 */
export const apiGetPoliciesPermissionsMetadata = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PoliciesPermissionsMetadataData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PoliciesPermissionsMetadataResponses, GetApiV1PoliciesPermissionsMetadataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/policies/permissions-metadata',
    ...options
});

/**
 * Get Access Policies
 *
 * Get the list of all access policies.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPolicies = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PoliciesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PoliciesResponses, GetApiV1PoliciesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/policies',
    ...options
});

/**
 * Get Access Policy By Uuid
 *
 * Get an access policy based on the given UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPoliciesUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PoliciesByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PoliciesByUuidResponses, GetApiV1PoliciesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/policies/{uuid}',
    ...options
});

/**
 * Update Access Policy
 *
 * Update an access policy given its UUID. A bit this update adds must be
 * one you hold yourself (`403` otherwise); removing is refused only on a
 * protected account (`423`), short of `VISIBILITY_SELF`, which narrows.
 * See `PERMISSIONS.md`, "Granting is bounded by the granter's bits".
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutPoliciesUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PoliciesByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PoliciesByUuidResponses, PutApiV1PoliciesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/policies/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Physicians
 *
 * Get list of physicians visible to the current user. Full-visibility users
 * see all physicians; other users see physicians within their visibility
 * scope (assigned physicians, assigned clinics' physicians, or physicians in
 * their regions).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPhysicians = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PhysiciansData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PhysiciansResponses, GetApiV1PhysiciansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/physicians',
    ...options
});

/**
 * Create Physician
 *
 * Create a new physician. The physician can be "empty" (clinic(s) and
 * patients) can be added later, or can be created with a list of clinics by
 * their UUIDs and/or list of patients by their IDs. Users without full
 * visibility must hold physician, clinics, or regions visibility, may not
 * connect users, may only reference clinics and patients within their
 * visibility scope, and the new physician must end up visible to them:
 * physician-visibility users get it assigned to their access policy, others
 * must create it within their regions or in one of their clinics. Note that
 * the geographical region (country, region) of a physician and their
 * associated clinic(s) and patients must match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPhysicians = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PhysiciansData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PhysiciansResponses, PostApiV1PhysiciansErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/physicians',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Physician
 *
 * Delete physician by its UUID, scoped to the user's visibility. The deleted
 * physician is automatically removed from a list of physicians of _all_
 * clinics, _all_ patients, all assigned monitoring users, and all access
 * policies.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeletePhysiciansUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1PhysiciansByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1PhysiciansByUuidResponses, DeleteApiV1PhysiciansByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/physicians/{uuid}',
    ...options
});

/**
 * Update Physician
 *
 * Update physician by its UUID. Users without full visibility may neither
 * connect nor disconnect users. Note that the geographical region (country,
 * region) of a physician and their associated clinic(s) and patients must
 * match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPhysiciansUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PhysiciansByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PhysiciansByUuidResponses, PutApiV1PhysiciansByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/physicians/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Clinics
 *
 * Get list of clinics visible to the current user. Full-visibility users
 * see all clinics; clinic-visibility users see assigned clinics;
 * region-visibility users see clinics in their regions;
 * physician-visibility users see no clinics.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinics = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ClinicsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ClinicsResponses, GetApiV1ClinicsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinics',
    ...options
});

/**
 * Create Clinic
 *
 * Create a new clinic. The clinic can be "empty" (physicians can be added
 * later), or can be created with a list of physicians by their UUIDs. Users
 * without full visibility must hold clinics or regions visibility, may only
 * reference physicians within their visibility scope, and the new clinic
 * must end up visible to them: clinic-visibility users get it assigned to
 * their access policy, region-visibility users must create it within their
 * regions. Note that the geographical region (country, region) of a clinic
 * and its physicians must match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinics = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicsResponses, PostApiV1ClinicsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Clinic
 *
 * Delete clinic by its UUID, scoped to the user's visibility. The deleted
 * clinic is automatically removed from a list of clinics of _all_
 * physicians, all assigned monitoring users, and all access policies.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicsByUuidResponses, DeleteApiV1ClinicsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinics/{uuid}',
    ...options
});

/**
 * Update Clinic
 *
 * Update clinic by its UUID. Note that the geographical region (country,
 * region) of a clinic and its physicians must match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicsByUuidResponses, PutApiV1ClinicsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinics/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preregister Physician
 *
 * Preregister a physician. Pre-registration is akin to creating a new user,
 * except the new user is set as _not active_, and their password is not set.
 * This endpoint sends a registration mail to the given user's email that
 * includes an URL pointing to the `finish-physician` endpoint, including
 * encoded one-time tokens.  For `expiry_timedelta`, we use `timedelta` data
 * type, which`pydantic` (de)serializes to JSON using ISO 8601 standard on
 * durations (see [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 * The email is sent using API background tasks and this endpoint return a task
 * ID, which then might be inquired for status using the `tasks/api/status/`
 * endpoint. The `physician` role's default permissions must be within the
 * ones you hold yourself (`403` otherwise).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostRegistrationPreregisterPhysician = <ThrowOnError extends boolean = true>(options: Options<PostApiV1RegistrationPreregisterPhysicianData, ThrowOnError>) => (options.client ?? client).post<PostApiV1RegistrationPreregisterPhysicianResponses, PostApiV1RegistrationPreregisterPhysicianErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/registration/preregister-physician',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish Registration Physician
 *
 * Finish registration of a physician. This endpoint takes tokens from the
 * `preregister_physician` endpoint and passwords the user wishes to use, saves
 * the password to the DB, and sets the user as active.
 */
export const apiPutRegistrationFinishPhysician = <ThrowOnError extends boolean = true>(options: Options<PutApiV1RegistrationFinishPhysicianData, ThrowOnError>) => (options.client ?? client).put<PutApiV1RegistrationFinishPhysicianResponses, PutApiV1RegistrationFinishPhysicianErrors, ThrowOnError>({
    url: '/api/v1/registration/finish-physician',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preregister Patient
 *
 * Preregister a patient. Pre-registration is akin to creating a new user,
 * except the new user is set as _not active_, and their password is not set.
 * This endpoint sends a registration mail to the given user's email that
 * includes an URL pointing to the `finish-patient` endpoint, including
 * encoded one-time tokens.  For `expiry_timedelta`, we use `timedelta` data
 * type, which`pydantic` (de)serializes to JSON using ISO 8601 standard on
 * durations (see [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 * The email is sent using API background tasks and this endpoint return a task
 * ID, which then might be inquired for status using the `tasks/api/status/`
 * endpoint. Subject to filtering by data visibility dimension, i.e.,
 * patient-managing roles can pre-register patient user only when their
 * `connected_patient_id` is managed by them.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostRegistrationPreregisterPatient = <ThrowOnError extends boolean = true>(options: Options<PostApiV1RegistrationPreregisterPatientData, ThrowOnError>) => (options.client ?? client).post<PostApiV1RegistrationPreregisterPatientResponses, PostApiV1RegistrationPreregisterPatientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/registration/preregister-patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Finish Registration Patient
 *
 * Finish registration of a patient. This endpoint takes tokens from the
 * `preregister_patient` endpoint and passwords the user wishes to use, saves
 * the password to the DB, and sets the user as active.
 */
export const apiPutRegistrationFinishPatient = <ThrowOnError extends boolean = true>(options: Options<PutApiV1RegistrationFinishPatientData, ThrowOnError>) => (options.client ?? client).put<PutApiV1RegistrationFinishPatientResponses, PutApiV1RegistrationFinishPatientErrors, ThrowOnError>({
    url: '/api/v1/registration/finish-patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Password Form
 *
 * Finish registration web form. This endpoint serves a simple web form given
 * the form type (finish patient registration, finish physician registration,
 * or password reset) and language. The web form is rendered from a `Jinja2`
 * template; the token and expiry token are given as query parameters, and the
 * submit button then redirects to the respective endpoint for finishing the
 * registration or resetting the password.
 */
export const apiGetRegistrationPasswordFormFormTypeLanguage = <ThrowOnError extends boolean = true>(options: Options<GetApiV1RegistrationPasswordFormByFormTypeByLanguageData, ThrowOnError>) => (options.client ?? client).get<GetApiV1RegistrationPasswordFormByFormTypeByLanguageResponses, GetApiV1RegistrationPasswordFormByFormTypeByLanguageErrors, ThrowOnError>({ url: '/api/v1/registration/password-form/{form_type}/{language}', ...options });

/**
 * Get Patient Counts
 *
 * Seerlinq patient counter! List number of patients in our DB and group them
 * based on: `patient_status`, `monitoring_type`, and `country`. Note that
 * patients are allowed to be in more than study and that patient is counted
 * towards all studies they are participating in.
 */
export const apiGetPatientsCounts = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PatientsCountsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PatientsCountsResponses, unknown, ThrowOnError>({ url: '/api/v1/patients/counts', ...options });

/**
 * Get Patients
 *
 * List all patients in the DB. This endpoint is subject to filtering by data
 * visibility dimension. Users with **self-only** visibility only get a list of
 * patient IDs, while higher access levels get a full schema response. The
 * `load_type` parameter controls how patients' connected data are returned:
 * `load_type=basic` returns just basic patient data without any related
 * medical data and `load_type=clinical` returns counts of related medical
 * (and other) data. For **monitoring access** and higher, this endpoint
 * returns also patients that did not sign or revoked their consent in the
 * minimal patient response schema.
 */
export const apiGetPatients = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PatientsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PatientsResponses, GetApiV1PatientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients',
    ...options
});

/**
 * Create Patient
 *
 * Create a new patient. A **self-only** user role cannot create new patients.
 * If a **managed** user role adds a new patient, it is automatically added to
 * their list of managing patient IDs. If a patient is added by a user with
 * **monitoring access** or higher, they can add this new patient to a list of
 * managed patient IDs of _any_ user with a **managed** visibility role.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Create Patients (52)`, `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPatients = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PatientsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PatientsResponses, PostApiV1PatientsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Patients List Minimal
 *
 * Return minimal info on all patients. Used mostly in a context where we
 * need the IDs of all patients, but not their full data.
 */
export const apiGetPatientsMinimal = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PatientsMinimalData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PatientsMinimalResponses, GetApiV1PatientsMinimalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/minimal',
    ...options
});

/**
 * Create Patient And Connected User
 *
 * Create a new patient and preregister a new user with the `patient` role,
 * connected to the newly created patient by its ID. A **self-only** user role
 * cannot create and preregister new patients. If a **managed** user role adds
 * a new patient, it is automatically added to their list of managing patient
 * IDs. If a patient is added by a user with **monitoring access** or higher,
 * they can add this new patient to a list of managed patient IDs of _any_
 * user with a **managed** visibility role. The new user is set as _not
 * active_, and their
 * password is not set. This endpoint sends a registration mail to the given
 * patient's email that includes an URL pointing to the `finish-patient`
 * endpoint, including encoded one-time tokens.  For `expiry_timedelta`, we use
 * `timedelta` data type, which`pydantic` (de)serializes to JSON using ISO 8601
 * standard on durations (see
 * [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)). The email is sent
 * using API background tasks and this endpoint return a task ID, which then
 * might be inquired for status using the `tasks/api/status/` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Create Patients (52)`, `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsPatientAndUser = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PatientsPatientAndUserData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PatientsPatientAndUserResponses, PostApiV1PatientsPatientAndUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/patient-and-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create User For Existing Patient
 *
 * Create a new user with the `patient` role for the existing patient. A
 * **self-only** user cannot create user for a patient. The patient DB item is
 * updated:
 * 1. the informed consent is revoked,
 * 2. patient status is set from the new study's monitoring settings; a
 * deceased patient is refused instead, with a 422,
 * 3. patient study is updated,
 * 4. and their email is updated to match the newly created user's email
 * / username.
 * The new user is set as _not active_, and their password is not set. This
 * endpoint sends a registration mail to the given patient's email that
 * includes an URL pointing to the `finish-patient` endpoint, including encoded
 * one-time tokens.  For `expiry_timedelta`, we use `timedelta` data type,
 * which`pydantic` (de)serializes to JSON using ISO 8601 standard on durations
 * (see [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)). The email is
 * sent using API background tasks and this endpoint return a task ID, which
 * then might be inquired for status using the `tasks/api/status/` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsPatientIdUser = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PatientsByPatientIdUserData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PatientsByPatientIdUserResponses, PostApiV1PatientsByPatientIdUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Patient
 *
 * Delete a patient by its patient ID. A **self-only** user role cannot delete
 * patients. This endpoint is subject to filtering by data visibility
 * dimension. The deleted patient ID is removed from the list of managed
 * patient IDs of _all_ users with a **managed** visibility role. Optionally
 * (by passing query parameter `delete_user`), all users connected to this
 * patient (i.e., with **self-only** visibility), added by the user who wants
 * to delete the patient, will also be deleted; service accounts they own are
 * flagged `owner_deactivated` first, as in `DELETE /users/{uuid}`. This
 * endpoint raises exception when used on protected patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeletePatientsPatientId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1PatientsByPatientIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1PatientsByPatientIdResponses, DeleteApiV1PatientsByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}',
    ...options
});

/**
 * Get Patient
 *
 * Get a single patient by its patient ID. This endpoint is subject to
 * filtering by data visibility dimension. The response type is `clinical` (see
 * `get_patients` endpoint), i.e., the patient's connected data are returned as
 * counts of diagnoses, medical data, medications, and symptoms. For
 * **monitoring access** and higher users, counts of patient's alerts,
 * thresholds, and events is also returned.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdResponses, GetApiV1PatientsByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}',
    ...options
});

/**
 * Update Patient
 *
 * Update/edit a patient given its patient ID. The **admin** role can update
 * all patients, **monitoring** users can update patients based on their
 * visibility, while lower access levels can update only patients they created.
 * This endpoint raises exception when used on protected patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPatientsPatientId = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PatientsByPatientIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PatientsByPatientIdResponses, PutApiV1PatientsByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Ai Output
 *
 * Append one AI output about a patient. Every earlier output stays
 * readable, and the endpoints serving the summary read the newest row of
 * that kind. The record written is the output, so the gate is
 * `AI_OUTPUT_WRITE` plus the patient's visibility - a bit that grants
 * nothing else, which is what keeps the writing account narrow. A repeat
 * of the same `source_run_id` carrying the same payload returns the stored
 * row, and one carrying a different payload is a 409.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ai Output Write (54)` <br /> See the _API description_ for more info.
 */
export const apiPostPatientsPatientIdAiOutputs = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PatientsByPatientIdAiOutputsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PatientsByPatientIdAiOutputsResponses, PostApiV1PatientsByPatientIdAiOutputsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/ai-outputs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Patient Consent
 *
 * Get patient informed consent status and its history over time.
 * Restricted to the patient themselves, managing users with visibility
 * of the patient, and admins - the same scope the consent write
 * endpoints enforce.
 */
export const apiGetPatientsPatientIdConsent = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdConsentData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdConsentResponses, GetApiV1PatientsByPatientIdConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/consent',
    ...options
});

/**
 * Approve Telemonitoring Consent
 *
 * Approve patient's informed consent for telemonitoring. This endpoint is
 * available **only** for users in the `patient` role that are connected to the
 * given patient ID and admins. Approving consent does **not** change the
 * patient's status.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutPatientsPatientIdApproveConsentTelemonitoring = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PatientsByPatientIdApproveConsentTelemonitoringResponses, PutApiV1PatientsByPatientIdApproveConsentTelemonitoringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/approve-consent-telemonitoring',
    ...options
});

/**
 * Approve Paper Consent
 *
 * Approve patient's informed consent for general monitoring (i.e., patients
 * did sign paper informed consent). This endpoint is available **only** for
 * **monitoring** users with patient visibility of the given patient ID and
 * admins. Approving consent does **not** change the patient's status.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPatientsPatientIdApproveConsentPaper = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PatientsByPatientIdApproveConsentPaperData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PatientsByPatientIdApproveConsentPaperResponses, PutApiV1PatientsByPatientIdApproveConsentPaperErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/approve-consent-paper',
    ...options
});

/**
 * Revoke Telemonitoring Consent
 *
 * Revoke patient's informed consent for telemonitoring. This endpoint is
 * available **only** for users in the `patient` role that are connected to the
 * given patient ID and admins. Revoking consent also changes patient's status
 * to `not active`, unless they are archived, deceased or test - those keep
 * theirs.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutPatientsPatientIdRevokeConsentTelemonitoring = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringResponses, PutApiV1PatientsByPatientIdRevokeConsentTelemonitoringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/revoke-consent-telemonitoring',
    ...options
});

/**
 * Revoke Paper Consent
 *
 * Revoke patient's informed consent for general monitoring (i.e., patients
 * did sign paper informed consent). This endpoint is available **only** for
 * **monitoring** users with patient visibility of the given patient ID and
 * admins. Revoking consent also changes patient's status to `not active`,
 * unless they are archived, deceased or test - those keep theirs.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPatientsPatientIdRevokeConsentPaper = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PatientsByPatientIdRevokeConsentPaperData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PatientsByPatientIdRevokeConsentPaperResponses, PutApiV1PatientsByPatientIdRevokeConsentPaperErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/revoke-consent-paper',
    ...options
});

/**
 * Generate Healthpro Reports For Patient
 *
 * Generate HealthPro reports for this patient ID. Health Pro reports are HTML
 * formatted strings that can be copy-pasted into the system. This endpoint
 * support reports timeline by selected the maximum number of reports to
 * generate (sorted by most recent) and by selecting the starting date for any
 * reports. For every date that patient did the measurement, we generate one
 * report. One measurement in this case is:
 * - PPG measurement in Condition 1 and Condition 2
 * - DRI
 * - EMD heart rate from Condition 1
 * - SpO2 from Condition 1
 * - shortness of breath and fatigue score symptoms
 * - systolic and diastolic blood pressure
 *
 * This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdHealthPro = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdHealthProData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdHealthProResponses, GetApiV1PatientsByPatientIdHealthProErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/health-pro',
    ...options
});

/**
 * Get Monitoring Info
 *
 * Get HeartCore monitoring info for a patient: last PPG and ECG, the last 5
 * DRIs and LVFPs (each only with its access bit), and complete full
 * measurements per 3/6/9/12-month window (`null` without a measurement
 * config).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Run Heart Core Quicklook (41)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdMonitoringInfo = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdMonitoringInfoData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdMonitoringInfoResponses, GetApiV1PatientsByPatientIdMonitoringInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/monitoring-info',
    ...options
});

/**
 * Get Patients Ppgs
 *
 * List all PPG data connected to this patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns the metadata
 * for PPG data, not the actual timeseries.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdPpgs = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdPpgsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdPpgsResponses, GetApiV1PatientsByPatientIdPpgsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/ppgs',
    ...options
});

/**
 * Get Patients Diagnoses
 *
 * List all diagnoses connected to this patient ID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdDiagnoses = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdDiagnosesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdDiagnosesResponses, GetApiV1PatientsByPatientIdDiagnosesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/diagnoses',
    ...options
});

/**
 * Get Patients Medical Data
 *
 * List all medical data connected to this patient ID. This endpoint is subject
 * to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdMedicaldata = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdMedicaldataData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdMedicaldataResponses, GetApiV1PatientsByPatientIdMedicaldataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/medicaldata',
    ...options
});

/**
 * Get Patients Medications
 *
 * List all medications connected to this patient ID. This endpoint is subject
 * to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdMedications = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdMedicationsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdMedicationsResponses, GetApiV1PatientsByPatientIdMedicationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/medications',
    ...options
});

/**
 * Get Gdmt Score
 *
 * Compute and return the full GDMT score breakdown for a patient.
 *
 * Score is persisted when it changes. Returns a not-applicable result
 * (score 0, empty medications) when no HF type is assigned.
 *
 * :param patient_id: patient to compute GDMT score for
 * :return: GDMTResult with per-medication breakdown and total score
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdGdmt = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdGdmtData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdGdmtResponses, GetApiV1PatientsByPatientIdGdmtErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/gdmt',
    ...options
});

/**
 * Get Patients Symptoms
 *
 * List all symptoms connected to this patient ID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdSymptoms = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdSymptomsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdSymptomsResponses, GetApiV1PatientsByPatientIdSymptomsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/symptoms',
    ...options
});

/**
 * Get Patient Questionnaires
 *
 * List all patient questionnaires connected to this patient ID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdQuestionnaires = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdQuestionnairesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdQuestionnairesResponses, GetApiV1PatientsByPatientIdQuestionnairesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/questionnaires',
    ...options
});

/**
 * Get Patients Computed Data
 *
 * List all Seerlinq-computed data connected to this patient ID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdComputed = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdComputedData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdComputedResponses, GetApiV1PatientsByPatientIdComputedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/computed',
    ...options
});

/**
 * Get Patients Derived Data
 *
 * List all PPG-derived data connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdDerived = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdDerivedData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdDerivedResponses, GetApiV1PatientsByPatientIdDerivedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/derived',
    ...options
});

/**
 * Get Patient Alerts
 *
 * List all patient alerts connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdAlerts = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdAlertsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdAlertsResponses, GetApiV1PatientsByPatientIdAlertsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/alerts',
    ...options
});

/**
 * Get Patient Thresholds
 *
 * List all patient-specific thresholds connected to this patient ID. This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdThresholds = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdThresholdsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdThresholdsResponses, GetApiV1PatientsByPatientIdThresholdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/thresholds',
    ...options
});

/**
 * Get Patient Events
 *
 * List all patient events connected to this patient ID. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdEvents = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdEventsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdEventsResponses, GetApiV1PatientsByPatientIdEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/events',
    ...options
});

/**
 * Get Patient Measurements
 *
 * Consolidated measurements table for one patient: one row per local day,
 * with its measurement sessions as sub-rows. Columns the user may not see
 * are absent from the payload.
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPatientsPatientIdMeasurements = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PatientsByPatientIdMeasurementsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PatientsByPatientIdMeasurementsResponses, GetApiV1PatientsByPatientIdMeasurementsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/patients/{patient_id}/measurements',
    ...options
});

/**
 * Create Ai Feedback
 *
 * Leave one reviewer's verdict on AI output. `output_uuid` judges that
 * output, `patient_id` the patient's outputs in general, and neither the
 * feature named by `kind`. Rows are appended, never updated.
 *
 * `output_uuid` or `patient_id` also requires visibility of that patient -
 * for an output, the output's own patient. An output or patient that does
 * not exist and one the caller cannot read both answer 404. Feedback on the
 * feature also requires `ACCESS_AI_CHAT`.
 *
 * Outside local and CI, and where harness is configured, each new verdict
 * is also forwarded to harness.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiPostAiFeedback = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AiFeedbackData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AiFeedbackResponses, PostApiV1AiFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Ai Output Feedback
 *
 * List the current feedback on one AI output: the newest verdict per
 * reviewer and `target`, with the rating scale ignored. A deleted
 * reviewer's verdicts stay stored but are not listed. An output that does
 * not exist and one the caller cannot read both answer 404.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAiOutputsUuidFeedback = <ThrowOnError extends boolean = true>(options: Options<GetApiV1AiOutputsByUuidFeedbackData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AiOutputsByUuidFeedbackResponses, GetApiV1AiOutputsByUuidFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-outputs/{uuid}/feedback',
    ...options
});

/**
 * List Supported Diagnoses
 *
 * List all supported diagnoses.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDiagnosesList = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1DiagnosesListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1DiagnosesListResponses, GetApiV1DiagnosesListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/diagnoses/list',
    ...options
});

/**
 * Get Diagnoses
 *
 * List all diagnoses in the DB. It is possible to filter by patient IDs and
 * search string based on the `diagnosis_name` field (we use the `glob` syntax,
 * where `*` matches any characters). This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDiagnoses = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1DiagnosesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1DiagnosesResponses, GetApiV1DiagnosesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/diagnoses',
    ...options
});

/**
 * Create Diagnosis
 *
 * Create a new diagnosis. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostDiagnoses = <ThrowOnError extends boolean = true>(options: Options<PostApiV1DiagnosesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1DiagnosesResponses, PostApiV1DiagnosesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/diagnoses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Diagnoses Bulk
 *
 * Create new diagnoses in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostDiagnosesBulk = <ThrowOnError extends boolean = true>(options: Options<PostApiV1DiagnosesBulkData, ThrowOnError>) => (options.client ?? client).post<PostApiV1DiagnosesBulkResponses, PostApiV1DiagnosesBulkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/diagnoses/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Diagnosis
 *
 * Delete a diagnosis by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteDiagnosesUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1DiagnosesByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1DiagnosesByUuidResponses, DeleteApiV1DiagnosesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/diagnoses/{uuid}',
    ...options
});

/**
 * Update Diagnosis
 *
 * Update/edit a diagnosis given its UUID. The **admin** role can update all
 * diagnoses, while lower access levels can update only diagnoses they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutDiagnosesUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1DiagnosesByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1DiagnosesByUuidResponses, PutApiV1DiagnosesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/diagnoses/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Supported Medical Data
 *
 * List all medical data measurement types supported by Seerlinq (blood
 * pressure, weight, lab results, etc.).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicaldataList = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MedicaldataListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MedicaldataListResponses, GetApiV1MedicaldataListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata/list',
    ...options
});

/**
 * Get Medical Data
 *
 * List clinical medical data (blood pressure, weight, lab results, etc.).
 * Filter by patient IDs, measurement type (glob syntax), and date range.
 * This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicaldata = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MedicaldataData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MedicaldataResponses, GetApiV1MedicaldataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata',
    ...options
});

/**
 * Create Medical Data
 *
 * Create new medical data. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicaldata = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicaldataData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicaldataResponses, PostApiV1MedicaldataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Last Medical Data Per Patient
 *
 * Get the last N medical data entries for a patient, ordered by measurement
 * date. Default N=5. This endpoint is subject to filtering by data visibility
 * dimension, last _N_ data points are taken after the filtering.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicaldataLast = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MedicaldataLastData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MedicaldataLastResponses, GetApiV1MedicaldataLastErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata/last',
    ...options
});

/**
 * Create Medical Data Bulk
 *
 * Create new medical data in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicaldataBulk = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicaldataBulkData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicaldataBulkResponses, PostApiV1MedicaldataBulkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Medical Data
 *
 * Delete medical data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMedicaldataUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MedicaldataByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MedicaldataByUuidResponses, DeleteApiV1MedicaldataByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata/{uuid}',
    ...options
});

/**
 * Update Medical Data
 *
 * Update/edit medical data given its UUID. The **admin** role can update all
 * medical data, while lower access levels can update only medical data they
 * created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicaldataUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MedicaldataByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MedicaldataByUuidResponses, PutApiV1MedicaldataByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medicaldata/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Medication Groups
 *
 * Return all medication drug classes; GDMT-scored classes carry a gdmt
 * section, and medications with dosages within those classes are
 * GDMT-relevant.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicationsMedicationGroups = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MedicationsMedicationGroupsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MedicationsMedicationGroupsResponses, GetApiV1MedicationsMedicationGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/medication-groups',
    ...options
});

/**
 * Get Medications
 *
 * List all medications in the DB. It is possible to filter by patient IDs and
 * search string based on the `medication_name` field (we use the `glob`
 * syntax, where `*` matches any characters). This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedications = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MedicationsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MedicationsResponses, GetApiV1MedicationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications',
    ...options
});

/**
 * Create Medication
 *
 * Create a new medication. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedications = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicationsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicationsResponses, PostApiV1MedicationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Medications Bulk
 *
 * Create new medications in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicationsBulk = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicationsBulkData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicationsBulkResponses, PostApiV1MedicationsBulkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Medication
 *
 * Delete a medication by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMedicationsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MedicationsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MedicationsByUuidResponses, DeleteApiV1MedicationsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/{uuid}',
    ...options
});

/**
 * Update Medication
 *
 * Update/edit a medication given its UUID. The **admin** role can update all
 * medications, while lower access levels can update only medications they
 * created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicationsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MedicationsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MedicationsByUuidResponses, PutApiV1MedicationsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Medication Dosage
 *
 * Change medication dose/dosage given its UUID. This updates the original
 * medication and sets its `medication_ended` date and creates a new record in
 * the medication table with the same patient ID and medication name, sets its
 * `medication_started` date and sets new dose, unit, and dosage. When creating
 * new medication, the fields that are not defined are copied over from the
 * original medication (i.e., setting only new dosage via this endpoint will
 * create a new medication with the same dose and unit as the old one). The
 * **admin** role can change dosage for all medications, **monitoring** users
 * can change medication dosage for patients based on their visibility, while
 * lower access levels can update only schedules they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicationsChangeUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MedicationsChangeByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MedicationsChangeByUuidResponses, PutApiV1MedicationsChangeByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medications/change/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Supported Symptoms
 *
 * List all supported symptoms.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSymptomsList = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1SymptomsListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SymptomsListResponses, GetApiV1SymptomsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/symptoms/list',
    ...options
});

/**
 * Get Symptoms
 *
 * List all symptoms in the DB. It is possible to filter by patient IDs and
 * search string based on the `symptom_name` field (we use the `glob` syntax,
 * where `*` matches any characters). This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSymptoms = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1SymptomsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SymptomsResponses, GetApiV1SymptomsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/symptoms',
    ...options
});

/**
 * Create Symptom
 *
 * Create a new symptom. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostSymptoms = <ThrowOnError extends boolean = true>(options: Options<PostApiV1SymptomsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SymptomsResponses, PostApiV1SymptomsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/symptoms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Last Symptoms Per Patient
 *
 * List the last _N_ symptoms for a given patient ID and given _N_, ordered
 * by symptom date. This endpoint is subject to filtering by data visibility
 * dimension, last _N_ data points are taken after the filtering.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSymptomsLast = <ThrowOnError extends boolean = true>(options: Options<GetApiV1SymptomsLastData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SymptomsLastResponses, GetApiV1SymptomsLastErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/symptoms/last',
    ...options
});

/**
 * Delete Symptom
 *
 * Delete a symptom by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteSymptomsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1SymptomsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SymptomsByUuidResponses, DeleteApiV1SymptomsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/symptoms/{uuid}',
    ...options
});

/**
 * Update Symptom
 *
 * Update/edit a symptom given its UUID. The **admin** role can update all
 * symptoms, while lower access levels can update only symptoms they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutSymptomsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1SymptomsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SymptomsByUuidResponses, PutApiV1SymptomsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/symptoms/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Questionnaire
 *
 * Get questionnaire definition given the questionnaire type and language.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesQuestionnaireTypeLanguage = <ThrowOnError extends boolean = true>(options: Options<GetApiV1QuestionnairesByQuestionnaireTypeByLanguageData, ThrowOnError>) => (options.client ?? client).get<GetApiV1QuestionnairesByQuestionnaireTypeByLanguageResponses, GetApiV1QuestionnairesByQuestionnaireTypeByLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/{questionnaire_type}/{language}',
    ...options
});

/**
 * Should Fill Questionnaire
 *
 * Check if given patient should fill the given questionnaire.
 */
export const apiGetQuestionnairesShouldFillQuestionnaireTypePatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdResponses, GetApiV1QuestionnairesShouldFillByQuestionnaireTypeByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/should-fill/{questionnaire_type}/{patient_id}',
    ...options
});

/**
 * Get Filled Questionnaires
 *
 * List of filled questionnaires in the DB. It is possible to filter by patient
 * IDs and questionnaire types. Moreover, user can select the strategy for
 * multiple questionnaires per patient, the endpoint can return all patients'
 * questionnaires, the last questionnaire per patient, or the first
 * questionnaire per patient. The `per_patient` parameter aggregates for each
 * questionnaire type. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnaires = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1QuestionnairesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1QuestionnairesResponses, GetApiV1QuestionnairesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires',
    ...options
});

/**
 * Fill Questionnaire
 *
 * Fill a questionnaire. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostQuestionnaires = <ThrowOnError extends boolean = true>(options: Options<PostApiV1QuestionnairesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1QuestionnairesResponses, PostApiV1QuestionnairesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Questionnaires Stats Per Patient
 *
 * Get summary of filled questionnaires for a given questionnaire type and
 * given patient ID. This returns a responses table with rows encoding
 * questions (as integers) and different filling times as columns. The last
 * column displays summary statistics (ordinal question -> median, continuous
 * question -> mean, choice questions -> mode). This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesStatsQuestionnaireTypePatientPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdResponses, GetApiV1QuestionnairesStatsByQuestionnaireTypePatientByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/stats/{questionnaire_type}/patient/{patient_id}',
    ...options
});

/**
 * Get Questionnaires Stats
 *
 * Get summary of filled questionnaires for a given questionnaire type for
 * multiple patients (possible to filter). One questionnaires is selected for
 * each patient based on `per_patient` query parameter: `last` takes the last
 * filled questionnaire per patient, `first` takes the first filled
 * questionnaire per patient, while `aggregate` aggregates all questionnaires
 * for each patient based on the same aggregation logic as summary statistics.
 * This returns a responses table with rows encoding patient IDs and questions
 * as columns. The last row displays summary statistics (ordinal question ->
 * median, continuous question -> mean, choice questions -> mode). This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetQuestionnairesStatsQuestionnaireTypeOverall = <ThrowOnError extends boolean = true>(options: Options<GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallData, ThrowOnError>) => (options.client ?? client).get<GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallResponses, GetApiV1QuestionnairesStatsByQuestionnaireTypeOverallErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/stats/{questionnaire_type}/overall',
    ...options
});

/**
 * Skip Questionnaire
 *
 * Record that a patient skipped a questionnaire instead of filling it in.
 * Only accepted if the questionnaire is configured as skippable for this
 * patient. This does not create a filled questionnaire - it just pushes
 * the next scheduled prompt out the same way a real fill would.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostQuestionnairesSkipQuestionnaireTypePatientId = <ThrowOnError extends boolean = true>(options: Options<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdData, ThrowOnError>) => (options.client ?? client).post<PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdResponses, PostApiV1QuestionnairesSkipByQuestionnaireTypeByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/skip/{questionnaire_type}/{patient_id}',
    ...options
});

/**
 * Delete Filled Questionnaire
 *
 * Delete filled questionnaire by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteQuestionnairesUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1QuestionnairesByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1QuestionnairesByUuidResponses, DeleteApiV1QuestionnairesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/{uuid}',
    ...options
});

/**
 * Update Filled Questionnaire
 *
 * Update/edit filled questionnaire given its UUID. The **admin** role can
 * update all questionnaires (and all fields) and **monitoring** users can
 * update questionnaires based on their visibility. Also, **monitoring** users
 * can only update questionnaire comment, not the actual responses.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutQuestionnairesUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1QuestionnairesByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1QuestionnairesByUuidResponses, PutApiV1QuestionnairesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/questionnaires/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Questionnaire V2
 *
 * Get questionnaire definition given the questionnaire type and language.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetV2QuestionnairesGetQuestionnaireTypeLanguage = <ThrowOnError extends boolean = true>(options: Options<GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageData, ThrowOnError>) => (options.client ?? client).get<GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageResponses, GetApiV2QuestionnairesGetByQuestionnaireTypeByLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/questionnaires/get/{questionnaire_type}/{language}',
    ...options
});

/**
 * Should Fill Questionnaires
 *
 * Check if given patient should fill any of the questionnaires (except
 * `dummy` questionnaire for testing purposes).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetV2QuestionnairesShouldFillPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV2QuestionnairesShouldFillByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV2QuestionnairesShouldFillByPatientIdResponses, GetApiV2QuestionnairesShouldFillByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v2/questionnaires/should-fill/{patient_id}',
    ...options
});

/**
 * Get Ppg Data
 *
 * List all PPG data in the DB. It is possible to filter by patient IDs,
 * measurement conditions, measurement devices, measurement origins, and by
 * specifying to -- from datetimes. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns only metadata of the PPG,
 * not the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpg = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PpgData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PpgResponses, GetApiV1PpgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg',
    ...options
});

/**
 * Get Last Ppg Data Per Patient
 *
 * List the last _N_ PPG data for a given patient ID and given _N_, ordered by
 * measurement datetime. This endpoint is subject to filtering by data
 * visibility dimension. This endpoint returns only metadata of the PPG, not
 * the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpgLast = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PpgLastData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PpgLastResponses, GetApiV1PpgLastErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/last',
    ...options
});

/**
 * Delete Ppg
 *
 * Delete PPG data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeletePpgUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1PpgByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1PpgByUuidResponses, DeleteApiV1PpgByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/{uuid}',
    ...options
});

/**
 * Get Ppg Data By Uuid
 *
 * Get single PPG data by its UUID. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns the actual PPG data time
 * series for users holding the `PPG_RAW` permission, otherwise returns only
 * metadata of the PPG.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPpgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1PpgByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PpgByUuidResponses, GetApiV1PpgByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/{uuid}',
    ...options
});

/**
 * Update Ppg
 *
 * Update/edit PPG data given its UUID. Fields that can be updated differ by
 * the user access (see schemas). **Medical** and **monitoring** users can
 * update PPG data that they did not create, but update rules are subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Meta (45)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutPpgUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1PpgByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1PpgByUuidResponses, PutApiV1PpgByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Smartcare Ppg
 *
 * Create a new PPG data measurement from a SmartCare device. This endpoint is
 * subject to filtering by data visibility dimension. The input schema is
 * passed as a query, and the actual CSV file is passed as multipart/form-data.
 * Calling this endpoint will change patient's status to `active` when
 * applicable.
 *
 * The PPG data created using this endpoint are sent to automatic processing to
 * `celery` algorithms. The following algorithms or workflows are automatically
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 * - `afib`: computes probability of atrial fibrillation in the data
 */
export const apiPostPpgSmartcare = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PpgSmartcareData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PpgSmartcareResponses, PostApiV1PpgSmartcareErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/smartcare',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Create Berry Oxi Ppg
 *
 * Create a new PPG data measurement from a Berry oximeter device. This
 * endpoint is subject to filtering by data visibility dimension. The data are
 * passed inside the JSON body. Calling this endpoint will change patient's
 * status to `active` when applicable.
 *
 * **Important note**: The PPG time series is passed as a list of lists of
 * floats (`list[list[float]]`), where the outer list length is 2 (as per 2
 * wavelengths: **red** and **IR** -- the order is _important_), and the inner
 * list length is the length of the measurement in samples.
 *
 * The PPG data created using this endpoint are sent to automatic processing to
 * `celery` algorithms. The following algorithms or workflows are automatically
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 * - `afib`: computes probability of atrial fibrillation in the data
 */
export const apiPostPpgBerry = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PpgBerryData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PpgBerryResponses, PostApiV1PpgBerryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/berry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Viatom Ppg
 *
 * Create a new PPG data measurement from a Viatom O2Ring-family device
 * (Oxyfit). This endpoint is subject to filtering by data visibility
 * dimension. The data are passed inside the JSON body. Calling this
 * endpoint will change patient's status to `active` when applicable.
 *
 * **Important note**: `state_bytes` come from separate parameter polls
 * interleaved into the waveform stream, so they may differ in length from
 * the PPG time series, or be empty.
 *
 * The PPG data created using this endpoint are sent to automatic
 * processing to `celery` algorithms. The following algorithms or workflows
 * are automatically triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 * - `afib`: computes probability of atrial fibrillation in the data
 */
export const apiPostPpgViatom = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PpgViatomData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PpgViatomResponses, PostApiV1PpgViatomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/viatom',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Samsung Watch Ppg
 *
 * Create a new PPG data measurement from a Samsung smartwatch device. This
 * endpoint is subject to filtering by data visibility dimension. The input
 * schema is passed as a query, and the actual CSV files (one per wavelength)
 * are passed as multipart/form-data. Calling this endpoint will change
 * patient's status to `active` when applicable.
 *
 * The PPG data created using this endpoint are sent to automatic processing to
 * `celery` algorithms. The following algorithms or workflows are automatically
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 */
export const apiPostPpgSamsung = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PpgSamsungData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PpgSamsungResponses, PostApiV1PpgSamsungErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/samsung',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Mobile App Ppg
 *
 * Create a new PPG data measurement from the mobile app using the built-in
 * camera. This endpoint is subject to filtering by data visibility dimension.
 * The data are passed inside the JSON body. Calling this endpoint will change
 * patient's status to `active` when applicable.
 */
export const apiPostPpgMobile = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PpgMobileData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PpgMobileResponses, PostApiV1PpgMobileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/mobile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Generic Ppg
 *
 * Create a new PPG generic data measurement. This endpoint is subject to
 * filtering by data visibility dimension. The data are passed inside the JSON
 * body.
 *
 * This endpoint optionally also sends PPG data for automatic processing
 * to `celery` algorithms. The following algorithms or workflows are optionally
 * triggered:
 * - `ppg_sqi_hr_rr`: computes SQI -> runs HR and RR algorithm
 * - `ppg_hf_dri_monitor`: computes SQI -> estimates DRI from matched PPGs ->
 * runs DRI monitoring algorithm (triggers an alert if the median is below
 * threshold)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPpgGeneric = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PpgGenericData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PpgGenericResponses, PostApiV1PpgGenericErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ppg/generic',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Ecg Data
 *
 * List all ECG data in the DB. It is possible to filter by patient IDs,
 * measurement devices, and by specifying to -- from datetimes. This endpoint
 * is subject to filtering by data visibility dimension. This endpoint returns
 * only metadata of the ECG, not the actual time series.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcg = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1EcgData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1EcgResponses, GetApiV1EcgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg',
    ...options
});

/**
 * Delete Ecg
 *
 * Delete ECG data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteEcgUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1EcgByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EcgByUuidResponses, DeleteApiV1EcgByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg/{uuid}',
    ...options
});

/**
 * Get Ecg Data By Uuid
 *
 * Get single ECG data by its UUID. This endpoint is subject to filtering by
 * data visibility dimension. This endpoint returns the actual ECG data time
 * series for users holding the `ECG_RAW` permission, otherwise returns only
 * metadata of the ECG.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1EcgByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EcgByUuidResponses, GetApiV1EcgByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg/{uuid}',
    ...options
});

/**
 * Update Ecg
 *
 * Update/edit ECG data given its UUID. Fields that can be updated differ by
 * the user access (see schemas). **Medical** and **monitoring** users can
 * update ECG data that they did not create, but update rules are subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ecg Meta (46)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutEcgUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1EcgByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EcgByUuidResponses, PutApiV1EcgByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Alivecor Ecg
 *
 * Create a new ECG data measurement from a AliveCor ECG devices. This endpoint
 * is subject to filtering by data visibility dimension. The data are passed
 * inside the JSON body.
 *
 * This endpoint takes only the measurement metadata and actual ECG time
 * series. To submit other data types, use appropriate endpoints _after_ this
 * request (as you will need UUID of newly saved ECG data for reference):
 * - average beat data block: TBA
 * - beat annotations + AliveCor algorithm determination:
 * `ecg-derived/alivecor`
 * - accelerometer data: TBA
 */
export const apiPostEcgAlivecor = <ThrowOnError extends boolean = true>(options: Options<PostApiV1EcgAlivecorData, ThrowOnError>) => (options.client ?? client).post<PostApiV1EcgAlivecorResponses, PostApiV1EcgAlivecorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg/alivecor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Generic Ecg
 *
 * Create a new ECG generic data measurement. This endpoint is subject to
 * filtering by data visibility dimension. The data are passed inside the JSON
 * body.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostEcgGeneric = <ThrowOnError extends boolean = true>(options: Options<PostApiV1EcgGenericData, ThrowOnError>) => (options.client ?? client).post<PostApiV1EcgGenericResponses, PostApiV1EcgGenericErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg/generic',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Auxiliary Time Series
 *
 * Get auxiliary time series data for patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliary = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AuxiliaryData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuxiliaryResponses, GetApiV1AuxiliaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary',
    ...options
});

/**
 * Delete Auxiliary Time Series
 *
 * Delete auxiliary time series data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteAuxiliaryUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1AuxiliaryByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1AuxiliaryByUuidResponses, DeleteApiV1AuxiliaryByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/{uuid}',
    ...options
});

/**
 * Get Auxiliary Time Series By Uuid
 *
 * Get auxiliary time series data by UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1AuxiliaryByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AuxiliaryByUuidResponses, GetApiV1AuxiliaryByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/{uuid}',
    ...options
});

/**
 * Get Auxiliary Data By Ecg Uuid
 *
 * Get all auxiliary data by original ECG UUID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryEcgEcgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1AuxiliaryEcgByEcgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AuxiliaryEcgByEcgUuidResponses, GetApiV1AuxiliaryEcgByEcgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/ecg/{ecg_uuid}',
    ...options
});

/**
 * Get Auxiliary Data By Ppg Uuid
 *
 * Get all auxiliary data by original PPG UUID. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAuxiliaryPpgPpgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1AuxiliaryPpgByPpgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AuxiliaryPpgByPpgUuidResponses, GetApiV1AuxiliaryPpgByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/ppg/{ppg_uuid}',
    ...options
});

/**
 * Create Auxiliary Time Series Accelerometer
 *
 * Create new auxiliary time series data for accelerometer.
 */
export const apiPostAuxiliaryAccelerometer = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuxiliaryAccelerometerData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuxiliaryAccelerometerResponses, PostApiV1AuxiliaryAccelerometerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/accelerometer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Auxiliary Time Series Gyrometer
 *
 * Create new auxiliary time series data for gyrometer.
 */
export const apiPostAuxiliaryGyrometer = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuxiliaryGyrometerData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuxiliaryGyrometerResponses, PostApiV1AuxiliaryGyrometerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/gyrometer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Alivecor Ecg
 *
 * Create a new alivecore data average beat measurement
 * from a AliveCor ECG devices.
 */
export const apiPostAuxiliaryAlivecorAvgBeat = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuxiliaryAlivecorAvgBeatData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuxiliaryAlivecorAvgBeatResponses, PostApiV1AuxiliaryAlivecorAvgBeatErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auxiliary/alivecor-avg-beat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Task
 *
 * Get the Label Studio task for the provided PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetLabelstudioTaskProjectIdPpgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1LabelstudioTaskByProjectIdByPpgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LabelstudioTaskByProjectIdByPpgUuidResponses, GetApiV1LabelstudioTaskByProjectIdByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/labelstudio/task/{project_id}/{ppg_uuid}',
    ...options
});

/**
 * Redirect
 *
 * Redirect to the Label Studio task for the provided PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetLabelstudioRedirectProjectIdPpgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1LabelstudioRedirectByProjectIdByPpgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LabelstudioRedirectByProjectIdByPpgUuidResponses, GetApiV1LabelstudioRedirectByProjectIdByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/labelstudio/redirect/{project_id}/{ppg_uuid}',
    ...options
});

/**
 * Get Medical Reports
 *
 * List all medical reports - subject to visibility filtering based on the
 * user's access level in relation to the patients linked with the reports.
 * Optionally filter by patient IDs, date range and report type.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReports = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MedicalReportsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MedicalReportsResponses, GetApiV1MedicalReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports',
    ...options
});

/**
 * Create Medical Report
 *
 * Create a new medical report - subject to visibility filtering based on the
 * user's access level in relation to the patient linked with the report.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReports = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicalReportsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicalReportsResponses, PostApiV1MedicalReportsErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Medical Report
 *
 * Delete a medical report by its UUID.
 *
 * 409 once a run was approved or rejected: that pair is ground truth and the
 * report is the only copy of what it was extracted from. Unreviewed runs
 * carry no such value and are dropped along with the report.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Monitoring Routers (11)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMedicalReportsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MedicalReportsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MedicalReportsByUuidResponses, DeleteApiV1MedicalReportsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}',
    ...options
});

/**
 * Get Medical Report
 *
 * Get all data about a single medical report by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MedicalReportsByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MedicalReportsByUuidResponses, GetApiV1MedicalReportsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}',
    ...options
});

/**
 * Update Medical Report
 *
 * Update a medical report by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicalReportsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MedicalReportsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MedicalReportsByUuidResponses, PutApiV1MedicalReportsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Medical Report
 *
 * Get a streaming response for a medical report object.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsDownloadUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MedicalReportsDownloadByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MedicalReportsDownloadByUuidResponses, GetApiV1MedicalReportsDownloadByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/download/{uuid}',
    ...options
});

/**
 * Get Medical Report Download Url
 *
 * Get a fresh pre-signed URL for downloading of a medical report object.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsUuidDownloadUrl = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MedicalReportsByUuidDownloadUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MedicalReportsByUuidDownloadUrlResponses, GetApiV1MedicalReportsByUuidDownloadUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/download-url',
    ...options
});

/**
 * Get Medical Report Upload Url
 *
 * Get a pre-signed URL for uploading a medical report. This endpoint
 * can be called repeatedly for re-uploads.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsUuidUploadUrl = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MedicalReportsByUuidUploadUrlData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MedicalReportsByUuidUploadUrlResponses, GetApiV1MedicalReportsByUuidUploadUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/upload-url',
    ...options
});

/**
 * Create Multifile Medical Report
 *
 * Create a medical report from multiple files either PDFs or images.
 * Accepts either multiple PDF or image files (JPG, PNG, JPEG)
 * Performs OCR on images using Tesseract, converts to PDF and merges all.
 * In case of PDFs, merges them directly with ghostscript.
 * Files are scanned by GuardDuty before processing.
 * Processing will be handled in the separate background worker to prevent
 * memory issues in the main API. The merged PDF is stored in S3 once
 * processing completes.
 * Workflow:
 * 1. Validate patient access and input files
 * 2. Reject the batch if this patient already has the whole of it, or
 * any one file in it
 * 3. Create medical report database record
 * 4. Upload files to S3 temporary location (uploads-multi/{uuid}_0, _1, etc.)
 * 5. Add report to upload queue for GuardDuty monitoring
 * 6. Background cron job checks GuardDuty scan results
 * 7. Once all files are scanned clean, background task:
 * - Downloads files from S3
 * - either: Converts images to PDFs (Tesseract OCR)
 * - or: Merges all PDFs (Ghostscript)
 * - Uploads final PDF to permanent location (reports/{patient_id}/{uuid})
 * - Updates medical report status
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsMultifile = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicalReportsMultifileData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicalReportsMultifileResponses, PostApiV1MedicalReportsMultifileErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/multifile',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Medical Report Extraction
 *
 * Get AI extraction results for a medical report.
 *
 * 404 while extraction has not produced anything, and 404 with a different
 * reason when the report was extracted before results were stored. Left on
 * MEDICAL_READ without the reviewer gate on purpose: reading one's own
 * extraction is not editing it.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMedicalReportsUuidExtraction = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MedicalReportsByUuidExtractionData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MedicalReportsByUuidExtractionResponses, GetApiV1MedicalReportsByUuidExtractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/extraction',
    ...options
});

/**
 * Save Medical Report Extraction Draft
 *
 * Save a reviewer's corrections over the stored extraction, before ingest.
 *
 * Applies the fields the request actually carries over the stored result and
 * stamps ``reviewed_at``; the extraction status is untouched, since
 * reviewing is not ingesting. Idempotent, so the frontend can autosave
 * freely — and a partial autosave never resets a field it did not send.
 *
 * The body's ``version`` must match the row's, otherwise the save is refused
 * with a 409; every save bumps it.
 *
 * The draft is written next to the model's output, never over it: the pair
 * is what makes an approved extraction usable as evaluation data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPutMedicalReportsUuidExtraction = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MedicalReportsByUuidExtractionData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MedicalReportsByUuidExtractionResponses, PutApiV1MedicalReportsByUuidExtractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/extraction',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Extract Medical Report Region
 *
 * Extract candidate entities from a reviewer-selected region of the report.
 *
 * Synchronous on purpose: this backs an interactive "I selected this, what is
 * in it?" action taken while reviewing, so it must answer within the request
 * rather than through the Taskiq pipeline the document-wide extraction uses.
 *
 * Nothing is written — the reviewer approves candidates in the UI and they
 * reach the store through the draft save (``PUT .../extraction``). It still
 * requires write permission rather than read: it is part of the authoring
 * flow, and each call costs an LLM request, so only reviewers who can
 * actually ingest may spend one.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsUuidExtractionExtractRegion = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicalReportsByUuidExtractionExtractRegionData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicalReportsByUuidExtractionExtractRegionResponses, PostApiV1MedicalReportsByUuidExtractionExtractRegionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/extraction/extract-region',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest Extraction Approval
 *
 * Ingest the saved draft's entities into the clinical DB.
 *
 * Writes them on the same contract as the sibling create endpoints — same
 * POST schemas, limiter, date-of-birth checks and background work — and
 * marks the report ``ingested``. Entities the caller may not write, or that
 * fail that validation, are counted into ``skipped`` rather than failing the
 * reviewer's whole batch; entities the reviewer flagged ``excluded`` are
 * left out of it entirely. A batch whose kept entities were all skipped is
 * refused with a 422, and the report stays reviewable.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsUuidExtractionIngest = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicalReportsByUuidExtractionIngestData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicalReportsByUuidExtractionIngestResponses, PostApiV1MedicalReportsByUuidExtractionIngestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/extraction/ingest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject Extraction
 *
 * Reject the extraction instead of ingesting it.
 *
 * Nothing is written to the clinical tables, but the current view is
 * snapshotted the way approval snapshots it: "the model produced this and
 * it was unusable" is a label the evaluation dataset cannot get anywhere
 * else.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsUuidExtractionReject = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicalReportsByUuidExtractionRejectData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicalReportsByUuidExtractionRejectResponses, PostApiV1MedicalReportsByUuidExtractionRejectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/extraction/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retry Extraction
 *
 * Re-trigger AI extraction for a report whose extraction failed, stalled, or
 * should simply be run again. Allowed on any report with
 * upload_status=success that has not been ingested yet.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMedicalReportsUuidExtractionRetry = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MedicalReportsByUuidExtractionRetryData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MedicalReportsByUuidExtractionRetryResponses, PostApiV1MedicalReportsByUuidExtractionRetryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/medical-reports/{uuid}/extraction/retry',
    ...options
});

/**
 * Get Ppg Derived Data
 *
 * List all PPG-derived data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerived = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1DerivedData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1DerivedResponses, GetApiV1DerivedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived',
    ...options
});

/**
 * Get Ppg Derived Data By Uuid
 *
 * Get single PPG-derived data by its UUID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerivedUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1DerivedByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1DerivedByUuidResponses, GetApiV1DerivedByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/{uuid}',
    ...options
});

/**
 * Update Ppg Derived Data
 *
 * Update single PPG-derived data given its UUID. **Monitoring** users can
 * update PPG-derived data that they did not create, but update rules are
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutDerivedUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1DerivedByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1DerivedByUuidResponses, PutApiV1DerivedByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Ppg Derived By Ppg Uuid
 *
 * Delete PPG-derived data by the original connected PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteDerivedPpgPpgUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1DerivedPpgByPpgUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1DerivedPpgByPpgUuidResponses, DeleteApiV1DerivedPpgByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/ppg/{ppg_uuid}',
    ...options
});

/**
 * Get Ppg Derived Data By Ppg Uuid
 *
 * Get all PPG-derived data by the original PPG UUID. This endpoint
 * is subject to filtering by data visibility dimension and to the
 * row-level access limiters of the `ppg_derived` table.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetDerivedPpgPpgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1DerivedPpgByPpgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1DerivedPpgByPpgUuidResponses, GetApiV1DerivedPpgByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/ppg/{ppg_uuid}',
    ...options
});

/**
 * Update Ppg Derived By Ppg Uuid
 *
 * Update PPG-derived data by the original connected PPG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutDerivedPpgPpgUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1DerivedPpgByPpgUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1DerivedPpgByPpgUuidResponses, PutApiV1DerivedPpgByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/ppg/{ppg_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Berry Oxi Ppg Derived Data
 *
 * Create new PPG-derived data. This endpoint is subject to filtering
 * by data visibility dimension.
 */
export const apiPostDerivedBerry = <ThrowOnError extends boolean = true>(options: Options<PostApiV1DerivedBerryData, ThrowOnError>) => (options.client ?? client).post<PostApiV1DerivedBerryResponses, PostApiV1DerivedBerryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/berry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Viatom Ppg Derived Data
 *
 * Create new PPG-derived data from a Viatom O2Ring-family device. This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Note that no HRV is produced: the device exposes no per-pulse interval
 * stream, so only SpO2 and pulse rate are aggregated here.
 */
export const apiPostDerivedViatom = <ThrowOnError extends boolean = true>(options: Options<PostApiV1DerivedViatomData, ThrowOnError>) => (options.client ?? client).post<PostApiV1DerivedViatomResponses, PostApiV1DerivedViatomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/derived/viatom',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Ecg Annotations
 *
 * List supported ECG annotations / SCP codes.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedScpCodes = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1EcgDerivedScpCodesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1EcgDerivedScpCodesResponses, GetApiV1EcgDerivedScpCodesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/scp-codes',
    ...options
});

/**
 * Get Ecg Derived Data
 *
 * List all ECG-derived data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerived = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1EcgDerivedData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1EcgDerivedResponses, GetApiV1EcgDerivedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived',
    ...options
});

/**
 * Get Ecg Derived Data By Uuid
 *
 * Get single ECG-derived data by its UUID. This endpoint is subject to
 * filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1EcgDerivedByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EcgDerivedByUuidResponses, GetApiV1EcgDerivedByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/{uuid}',
    ...options
});

/**
 * Update Ecg Derived Data
 *
 * Update single ECG-derived data given its UUID. **Monitoring** users can
 * update ECG-derived data that they did not create, but update rules are
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutEcgDerivedUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1EcgDerivedByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EcgDerivedByUuidResponses, PutApiV1EcgDerivedByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Ecg Derived By Ecg Uuid
 *
 * Delete ECG-derived data by the original connected ECG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteEcgDerivedEcgEcgUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1EcgDerivedEcgByEcgUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EcgDerivedEcgByEcgUuidResponses, DeleteApiV1EcgDerivedEcgByEcgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/ecg/{ecg_uuid}',
    ...options
});

/**
 * Get Ecg Derived Data By Ecg Uuid
 *
 * Get all ECG-derived data by the original ECG UUID. This endpoint
 * is subject to filtering by data visibility dimension and to the
 * row-level access limiters of the `ecg_derived` table.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetEcgDerivedEcgEcgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1EcgDerivedEcgByEcgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1EcgDerivedEcgByEcgUuidResponses, GetApiV1EcgDerivedEcgByEcgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/ecg/{ecg_uuid}',
    ...options
});

/**
 * Update Ecg Derived By Ecg Uuid
 *
 * Update ECG-derived data by the original connected ECG UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutEcgDerivedEcgEcgUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1EcgDerivedEcgByEcgUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EcgDerivedEcgByEcgUuidResponses, PutApiV1EcgDerivedEcgByEcgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/ecg/{ecg_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Alivecor Ecg Derived Data
 *
 * Create new ECG-derived data from AliveCor ECG device. This endpoint is
 * subject to filtering by data visibility dimension.
 */
export const apiPostEcgDerivedAlivecor = <ThrowOnError extends boolean = true>(options: Options<PostApiV1EcgDerivedAlivecorData, ThrowOnError>) => (options.client ?? client).post<PostApiV1EcgDerivedAlivecorResponses, PostApiV1EcgDerivedAlivecorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ecg-derived/alivecor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Computed Data
 *
 * List all Seerlinq-computed data in the DB. It is possible to filter by
 * patient IDs and search string based on the `measurement_type` field (we use
 * the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputed = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ComputedData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ComputedResponses, GetApiV1ComputedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed',
    ...options
});

/**
 * Create Computed Data
 *
 * Create new Seerlinq-computed data. This endpoint is available only for
 * Seerlinq algorithms (**monitoring access** + username filtering) and
 * **admin** users.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostComputed = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ComputedData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ComputedResponses, PostApiV1ComputedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Lvfp Indication
 *
 * Whether the LVFP computed for the condition-matched pair this recording
 * belongs to reaches the screening threshold - a boolean, never the
 * value. Either recording of the pair answers. Poll while `status` is
 * `unpaired` or `pending`; `ready`, `too_short` and `failed` are terminal.
 *
 * Also needs `ACCESS_LVFP`, or `ALLOW_PAYMENT` for a screening patient.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedPpgPpgUuidLvfpIndication = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ComputedPpgByPpgUuidLvfpIndicationData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ComputedPpgByPpgUuidLvfpIndicationResponses, GetApiV1ComputedPpgByPpgUuidLvfpIndicationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed/ppg/{ppg_uuid}/lvfp-indication',
    ...options
});

/**
 * Get Computed Data By Ppg Uuid
 *
 * List all Seerlinq-computed by the PPG UUID they are connected to. This
 * endpoint is subject to filtering by data visibility dimension and to the
 * row-level access limiters of the `sq_computed` table (DRI/LVFP/AFib).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedPpgPpgUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ComputedPpgByPpgUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ComputedPpgByPpgUuidResponses, GetApiV1ComputedPpgByPpgUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed/ppg/{ppg_uuid}',
    ...options
});

/**
 * Get Last Computed Data Per Patient
 *
 * List the last _N_ Seerlinq-computed data for a given patient ID and given
 * _N_, ordered by measurement datetime. This endpoint is subject to filtering
 * by data visibility dimension, last _N_ data points are taken after the
 * filtering.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetComputedLast = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ComputedLastData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ComputedLastResponses, GetApiV1ComputedLastErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed/last',
    ...options
});

/**
 * Delete Computed Data
 *
 * Delete Seerlinq-computed data by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteComputedUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ComputedByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ComputedByUuidResponses, DeleteApiV1ComputedByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed/{uuid}',
    ...options
});

/**
 * Update Computed Data
 *
 * Update/edit Seerlinq-computed data given its UUID. Fields that can be
 * updated differ by the user access (see schemas). **Medical** and
 * **monitoring** users can update Seerlinq-computed data that they did not
 * create, but update rules are subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutComputedUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ComputedByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ComputedByUuidResponses, PutApiV1ComputedByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/computed/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Study Enrollments
 *
 * List of clinical study enrollments in the DB. It is possible to filter by
 * patient IDs and study acronyms. This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudies = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ClinicalStudiesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ClinicalStudiesResponses, GetApiV1ClinicalStudiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies',
    ...options
});

/**
 * Get Study Definition
 *
 * Get clinical study definition (protocol).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesStudyAcronymDefinition = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ClinicalStudiesByStudyAcronymDefinitionData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ClinicalStudiesByStudyAcronymDefinitionResponses, GetApiV1ClinicalStudiesByStudyAcronymDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/{study_acronym}/definition',
    ...options
});

/**
 * Get Study Visits
 *
 * List all study visits under a clinical study. It is possible to filter by
 * patient IDs. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesStudyAcronymVisits = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ClinicalStudiesByStudyAcronymVisitsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ClinicalStudiesByStudyAcronymVisitsResponses, GetApiV1ClinicalStudiesByStudyAcronymVisitsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/{study_acronym}/visits',
    ...options
});

/**
 * Prefill Enrollment
 *
 * Get prefill data for patient enrollment, mainly generated schedule.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesStudyAcronymEnrollPreFill = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillResponses, GetApiV1ClinicalStudiesByStudyAcronymEnrollPreFillErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/{study_acronym}/enroll-pre-fill',
    ...options
});

/**
 * Prefill Study Visit With Data
 *
 * Get study visit prefill data. Given the study visit UUID, this will return
 * the visit data as per definition and for each data type the data that has
 * been already associated and possible existing data in the DB. This endpoint
 * is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesVisitUuidDataPreFill = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ClinicalStudiesByVisitUuidDataPreFillData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ClinicalStudiesByVisitUuidDataPreFillResponses, GetApiV1ClinicalStudiesByVisitUuidDataPreFillErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/{visit_uuid}/data-pre-fill',
    ...options
});

/**
 * Enroll Patient To Study
 *
 * Enroll patient to a clinical study. The study enrollment for a specific
 * study (`study_acronym`) must be unique per patient. This endpoint is subject
 * to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesEnroll = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesEnrollData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesEnrollResponses, PostApiV1ClinicalStudiesEnrollErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/enroll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Study Visit
 *
 * Create study visit for a patient in a particular clinical study. The study
 * visit for a specific study (`study_acronym`), protocol version
 * (`protocol_version`), and visit type (`visit_type`) must be unique per
 * patient. New study visit cannot be added when the parent patient's
 * enrollment is marked as **inactive**. This endpoint is subject to filtering
 * by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesStudyVisit = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesStudyVisitData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesStudyVisitResponses, PostApiV1ClinicalStudiesStudyVisitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/study-visit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Admin Procedures
 *
 * Create admin procedures for a study visit in bulk. This is possible for a
 * single patient ID and single clinical study visit UUID. New administrative
 * procedure(s) cannot be added when the parent patient's enrollment is marked
 * as **inactive**.This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAdminProcedure = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAdminProcedureData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAdminProcedureResponses, PostApiV1ClinicalStudiesAdminProcedureErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/admin-procedure',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Patient Enrollment
 *
 * Delete patient enrollment to the clinical study by its UUID. This will also
 * delete all study visits under this study enrollment (cascade) and admin
 * procedures under the study visits.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesEnrollmentUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesEnrollmentByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesEnrollmentByUuidResponses, DeleteApiV1ClinicalStudiesEnrollmentByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/enrollment/{uuid}',
    ...options
});

/**
 * Update Patient Enrollment
 *
 * Update/edit patient's study enrollment given its UUID. The **admin** role
 * can update all study enrollments, while lower access levels can update only
 * study enrollments they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesEnrollmentUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesEnrollmentByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesEnrollmentByUuidResponses, PutApiV1ClinicalStudiesEnrollmentByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/enrollment/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Study Visit
 *
 * Delete patient's clinical study visit by its UUID. This will also delete all
 * admin procedures under this study visit.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesStudyVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesStudyVisitByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesStudyVisitByUuidResponses, DeleteApiV1ClinicalStudiesStudyVisitByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/study-visit/{uuid}',
    ...options
});

/**
 * Update Study Visit
 *
 * Update/edit patient's study visit given its UUID. The **admin** role can
 * update all study visits, while lower access levels can update only study
 * visits they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesStudyVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesStudyVisitByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesStudyVisitByUuidResponses, PutApiV1ClinicalStudiesStudyVisitByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/study-visit/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Admin Procedure
 *
 * Delete clinical study visit admin procedure by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAdminProcedureUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAdminProcedureByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAdminProcedureByUuidResponses, DeleteApiV1ClinicalStudiesAdminProcedureByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/admin-procedure/{uuid}',
    ...options
});

/**
 * Update Admin Procedure
 *
 * Update/edit patient's administrative procedure given its UUID. The **admin**
 * role can update all administrative procedures, while lower access levels can
 * update only administrative procedures they created.
 *
 * When procedure is marked done, automatically executes configured side
 * effects if not yet completed. Idempotent and safe to retry - will
 * auto-recover on next update if side effects fail.
 *
 * The side effect behavior is configuration-driven, allowing different
 * studies to define which procedures trigger which effects via JSON.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAdminProcedureUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAdminProcedureByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAdminProcedureByUuidResponses, PutApiV1ClinicalStudiesAdminProcedureByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/admin-procedure/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Study Overview
 *
 * Get clinical study overview - all enrolled patients and status of their
 * visits. This returns a table with patient IDs as rows and individual status
 * of a study visit as columns. The detailed overview gives individual also
 * individual data as per visit definition with their respective statuses,
 * while simple (`detailed = False`) overview gives one status per visit.
 * Possible statuses of an individual visit are:
 * - `not-scheduled`: visit does not exists in the DB, so it's not scheduled
 * - `scheduled`: visit exists in the DB, but has no associated data
 * - `started`: visit exists in the DB, but not all required data were
 * associated
 * - `done-required`: visit has all required data points associated
 * - `done-incl-optional`: visit has all required and optional data points
 * associated
 * - `done-multiple`: visit has multiple associated data points for the single
 * required data as per visit definition
 *
 * Possible statuses of individual data are:
 * - `incomplete` - datapoint is not associated
 * - `incomplete-optional` - datapoint is not associated and is optional
 * - `done` - datapoint is associated
 * - `done-multiple` - more than one datapoint is associated
 *
 * This endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesStudyAcronymOverviewOverall = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallResponses, GetApiV1ClinicalStudiesByStudyAcronymOverviewOverallErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/{study_acronym}/overview/overall',
    ...options
});

/**
 * Get Study Patient Overview
 *
 * Get clinical study overview per patient. This returns a table with
 * individual planned datapoints per visit as rows and visits as columns.
 * Possible statuses of individual data are:
 * - `incomplete` - datapoint is not associated
 * - `incomplete-optional` - datapoint is not associated and is optional
 * - `done` - datapoint is associated
 * - `done-multiple` - more than one datapoint is associated
 * - `None` - data point is not planned for a given visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesStudyAcronymOverviewPatientPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdResponses, GetApiV1ClinicalStudiesByStudyAcronymOverviewPatientByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/{study_acronym}/overview/patient/{patient_id}',
    ...options
});

/**
 * Get Calendar
 *
 * Get calendar of clinical study visits. Possible to filter by clinical
 * studies, patient IDs, and limit from and to datetimes. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Clinical Studies (51)`, `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetClinicalStudiesCalendar = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ClinicalStudiesCalendarData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ClinicalStudiesCalendarResponses, GetApiV1ClinicalStudiesCalendarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/calendar',
    ...options
});

/**
 * Associate Diagnoses To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationDiagnoses = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationDiagnosesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationDiagnosesResponses, PostApiV1ClinicalStudiesAssociationDiagnosesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/diagnoses',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Diagnosis From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/diagnoses/{diagnosis_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Diagnosis Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationDiagnosesDiagnosisUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationDiagnosesByDiagnosisUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/diagnoses/{diagnosis_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Medical Data To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationMedicalData = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationMedicalDataData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationMedicalDataResponses, PostApiV1ClinicalStudiesAssociationMedicalDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medical-data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Medical Data From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medical-data/{medical_data_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Medical Data Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationMedicalDataByMedicalDataUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medical-data/{medical_data_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Medical Reports To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationMedicalReports = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationMedicalReportsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationMedicalReportsResponses, PostApiV1ClinicalStudiesAssociationMedicalReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medical-reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Medical Report From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationMedicalReportsMedicalReportUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medical-reports/{medical_report_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Medical Report Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationMedicalReportsMedicalReportUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationMedicalReportsByMedicalReportUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medical-reports/{medical_report_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Medications To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationMedications = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationMedicationsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationMedicationsResponses, PostApiV1ClinicalStudiesAssociationMedicationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Medication From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationMedicationsMedicationUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medications/{medication_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Medication Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationMedicationsMedicationUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationMedicationsByMedicationUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/medications/{medication_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Symptoms To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationSymptoms = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationSymptomsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationSymptomsResponses, PostApiV1ClinicalStudiesAssociationSymptomsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/symptoms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Symptom From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/symptoms/{symptom_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Symptom Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationSymptomsBySymptomUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/symptoms/{symptom_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Questionnaires To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationQuestionnaires = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationQuestionnairesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationQuestionnairesResponses, PostApiV1ClinicalStudiesAssociationQuestionnairesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/questionnaires',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Questionnaire From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationQuestionnairesQuestionnaireUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/questionnaires/{questionnaire_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Questionnaire Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationQuestionnairesQuestionnaireUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationQuestionnairesByQuestionnaireUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/questionnaires/{questionnaire_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Events To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationEvents = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationEventsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationEventsResponses, PostApiV1ClinicalStudiesAssociationEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Event From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationEventsEventUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/events/{event_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Event Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationEventsEventUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationEventsByEventUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/events/{event_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Ppgs To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationPpgs = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationPpgsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationPpgsResponses, PostApiV1ClinicalStudiesAssociationPpgsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/ppgs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Ppg From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationPpgsPpgUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/ppgs/{ppg_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Ppg Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationPpgsPpgUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationPpgsByPpgUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/ppgs/{ppg_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Computed Data To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationComputed = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationComputedData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationComputedResponses, PostApiV1ClinicalStudiesAssociationComputedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/computed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Computed From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationComputedComputedUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/computed/{computed_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Computed Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationComputedComputedUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationComputedByComputedUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/computed/{computed_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Associate Derived Data To Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostClinicalStudiesAssociationDerived = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ClinicalStudiesAssociationDerivedData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ClinicalStudiesAssociationDerivedResponses, PostApiV1ClinicalStudiesAssociationDerivedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/derived',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove Derived From Study Visit
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Medical Routers (10)` <br /> See the _API description_ for more info.
 */
export const apiDeleteClinicalStudiesAssociationDerivedDerivedUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponses, DeleteApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/derived/{derived_uuid}/{visit_uuid}',
    ...options
});

/**
 * Update Derived Visit Association
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutClinicalStudiesAssociationDerivedDerivedUuidVisitUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidResponses, PutApiV1ClinicalStudiesAssociationDerivedByDerivedUuidByVisitUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/clinical-studies/association/derived/{derived_uuid}/{visit_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Alerts
 *
 * List all alerts in the DB. It is possible to filter by patient IDs and
 * search string based on the `alert_variable` field (we use the `glob` syntax,
 * where `*` matches any characters). This endpoint is subject to filtering by
 * data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiGetAlerts = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AlertsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AlertsResponses, GetApiV1AlertsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts',
    ...options
});

/**
 * Create Alert
 *
 * Create an alert for given data. This endpoint optionally sends an alert
 * email to patient's monitoring physician(s). This endpoint is available only
 * for Seerlinq algorithms (monitoring access + username filtering)
 * and admin users. For more info on alerts, see the _Seerlinq Alerting_
 * description.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Alerts (31)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostAlerts = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AlertsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AlertsResponses, PostApiV1AlertsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Alert
 *
 * Delete alert by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteAlertsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1AlertsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1AlertsByUuidResponses, DeleteApiV1AlertsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/{uuid}',
    ...options
});

/**
 * Update Alert
 *
 * Update/edit alert given its UUID. The **admin** role can update all alerts
 * and **monitoring** users can update alerts based on their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1AlertsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1AlertsByUuidResponses, PutApiV1AlertsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Medical Waiting Room
 *
 * List medical waiting room. This endpoints lists the aggregate waiting room
 * for a given timespan (30 days by default), where each row details a patient
 * with their risk score (computed as a temporally discounted sum of all alerts
 * with optional weights). The temporal discounting for computing the risk
 * score can be changed using query parameter. The patient visibility is
 * determined using the following key:
 * - users with **monitoring access+** and the **full visibility**:
 * _all_ patients that are in the waiting room
 * - monitoring team **admin** or **member**: _all_ patients from a
 * **region(s)** (and potentially **clinics**) of that team
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsMedicalWaitingRoom = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AlertsMedicalWaitingRoomData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AlertsMedicalWaitingRoomResponses, GetApiV1AlertsMedicalWaitingRoomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/medical-waiting-room',
    ...options
});

/**
 * List Technical Waiting Room
 *
 * List technical waiting room. This endpoints lists the aggregate waiting room
 * for a given timespan (30 days by default), where each row details a patient.
 * The patient visibility is determined using the following key:
 * - users with **monitoring access+** and the **full visibility**:
 * _all_ patients that are in the waiting room
 * - monitoring team **admin** or **member**: _all_ patients from a
 * **region(s)** (and potentially **clinics**) of that team
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsTechnicalWaitingRoom = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AlertsTechnicalWaitingRoomData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AlertsTechnicalWaitingRoomResponses, GetApiV1AlertsTechnicalWaitingRoomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/technical-waiting-room',
    ...options
});

/**
 * List Audit Room
 *
 * List alerting audit room, i.e., the patients that did not receive an alert
 * for at least 21 days and it's safe to audit them. The patient visibility is
 * determined using the following key:
 * - users with **monitoring access+** and the **full visibility**:
 * _all_ patients that are in the waiting room
 * - monitoring team **admin** or **member**: _all_ patients from a
 * **region(s)** (and potentially **clinics**) of that team
 *
 * Use `X-Cache-Refresh: true` header to force cache refresh and bypass
 * stale data.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsAuditRoom = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AlertsAuditRoomData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AlertsAuditRoomResponses, GetApiV1AlertsAuditRoomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/audit-room',
    ...options
});

/**
 * Mark Alert Seen
 *
 * Mark given alert as seen by its UUID. For more info on alerts, see the
 * _Seerlinq Alerting_ description. The **admin** role can mark as seen all
 * alerts and **medical** and **monitoring** users can validate alerts based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsMarkSeenUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1AlertsMarkSeenByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1AlertsMarkSeenByUuidResponses, PutApiV1AlertsMarkSeenByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/mark-seen/{uuid}',
    ...options
});

/**
 * Mark All Alerts Seen
 *
 * Mark all alerts for a given patient ID and of given kind(s) as seen. For
 * more info on alerts, see the _Seerlinq Alerting_ description. The **admin**
 * role can mark as seen all alerts and **medical** and **monitoring**
 * users can mark alerts as seen based on their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsMarkAllSeenPatientId = <ThrowOnError extends boolean = true>(options: Options<PutApiV1AlertsMarkAllSeenByPatientIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1AlertsMarkAllSeenByPatientIdResponses, PutApiV1AlertsMarkAllSeenByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/mark-all-seen/{patient_id}',
    ...options
});

/**
 * Update Waiting Room Patient
 *
 * Update the waiting-room-editable subset of a patient's fields (risk flag,
 * the two monitoring notes, and the four monitoring statuses) given its
 * patient ID. Gated on the waiting-room policy so anyone who can view the
 * waiting room can also act on it, scoped to their patient visibility. Raises
 * when used on protected patients.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Waiting Room (30)` <br /> See the _API description_ for more info.
 */
export const apiPutAlertsPatientIdWaitingRoom = <ThrowOnError extends boolean = true>(options: Options<PutApiV1AlertsByPatientIdWaitingRoomData, ThrowOnError>) => (options.client ?? client).put<PutApiV1AlertsByPatientIdWaitingRoomResponses, PutApiV1AlertsByPatientIdWaitingRoomErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/{patient_id}/waiting-room',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Validate Alert
 *
 * Validate alert given its UUID. When the alert is validated, the alert
 * quality is automatically computed as a difference between automatic
 * `alert_type` and user-defined `alert_validation` fields. For more info on
 * alerts, see the _Seerlinq Alerting_ description. The **admin** role can
 * validate all alerts and **monitoring** users can validate alerts based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Alerts (31)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostAlertsValidateUuid = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AlertsValidateByUuidData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AlertsValidateByUuidResponses, PostApiV1AlertsValidateByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/validate/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Source Alert Data
 *
 * Get source data for an alert given alert UUID. The source data for the alert
 * can be either medical data, symptom, Seerlinq-computed data, PPG-derived
 * data, or ECG-derived data. The **admin** role can retrieve all source data
 * for alerts and **monitoring** users can retrieve source data alerts based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Alerts (31)` <br /> See the _API description_ for more info.
 */
export const apiGetAlertsSourceDataUuid = <ThrowOnError extends boolean = true>(options: Options<GetApiV1AlertsSourceDataByUuidData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AlertsSourceDataByUuidResponses, GetApiV1AlertsSourceDataByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/alerts/source-data/{uuid}',
    ...options
});

/**
 * Get Schedules
 *
 * List all patients' schedules. It is possible to filter by patient IDs,
 * schedule types, and specific data names regarding the schedule. This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedules = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1SchedulesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SchedulesResponses, GetApiV1SchedulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules',
    ...options
});

/**
 * Create Schedule
 *
 * Create a new patient schedule. A **self-only** user role cannot create new
 * patient's schedule. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostSchedules = <ThrowOnError extends boolean = true>(options: Options<PostApiV1SchedulesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SchedulesResponses, PostApiV1SchedulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Schedule
 *
 * Delete a schedule by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteSchedulesUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1SchedulesByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1SchedulesByUuidResponses, DeleteApiV1SchedulesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules/{uuid}',
    ...options
});

/**
 * Update Schedule
 *
 * Update/edit a schedule given its UUID. The **admin** role can update all
 * schedules, **monitoring** users can update patient schedules based on their
 * visibility, while lower access levels can update only schedules they
 * created. **Self-roles** (typically users in the `patient` role) can only
 * update schedule times.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutSchedulesUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1SchedulesByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1SchedulesByUuidResponses, PutApiV1SchedulesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Check Schedule Done
 *
 * Check whether the given patient finished their scheduled measurements. This
 * reads all **active** schedules for a given patient ID, checks whether those
 * schedules are within a date/time window (i.e., now minus given
 * `check_back_window`), and then checks whether all scheduled measurements are
 * recorded in the DB. The `schedule_timedelta` allows for a wiggle room, and
 * the difference between actual measurement times and scheduled times is
 * computed as an absolute value. For `schedule_timedelta` and
 * `check_back_window` we use `timedelta` data type, which `pydantic`
 * (de)serializes to JSON using ISO 8601 standard on durations (see
 * [here](https://en.wikipedia.org/wiki/ISO_8601#Durations)).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesCheckPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1SchedulesCheckByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SchedulesCheckByPatientIdResponses, GetApiV1SchedulesCheckByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules/check/{patient_id}',
    ...options
});

/**
 * Get Next Measurement
 *
 * Get the next scheduled measurement time for a patient in their
 * timezone.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesNextMeasurementPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1SchedulesNextMeasurementByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SchedulesNextMeasurementByPatientIdResponses, GetApiV1SchedulesNextMeasurementByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules/next-measurement/{patient_id}',
    ...options
});

/**
 * Get Compliance
 *
 * Get schedule compliance for a patient in their timezone. Each schedule
 * reports two ratios: `compliance_ratio` is hard, day-exact adherence to the
 * anchored grid as required for regulatory reporting; `soft_compliance_ratio`
 * is frequency-tolerant, allowing measurement days up to
 * `soft_tolerance_days` off the grid.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetSchedulesCompliancePatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1SchedulesComplianceByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1SchedulesComplianceByPatientIdResponses, GetApiV1SchedulesComplianceByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/schedules/compliance/{patient_id}',
    ...options
});

/**
 * Get Thresholds
 *
 * List all patient-specific threshold in the DB. It is possible to filter by
 * patient IDs and search string based on the `threshold_variable` field (we
 * use the `glob` syntax, where `*` matches any characters). This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiGetThresholds = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ThresholdsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ThresholdsResponses, GetApiV1ThresholdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/thresholds',
    ...options
});

/**
 * Create Threshold
 *
 * Create new patient-specific threshold. The threshold for a single variable
 * (`threshold_variable`), trigger (`threshold_trigger`), type
 * (`threshold_type`), and same "threshold settings" (`threshold_settings`)
 * must be unique per patient. When user tries to create new threshold for the
 * same patient ID, same threshold variable, same trigger, same type, and with
 * same threshold settings, this endpoint raises an error. To update
 * patient-specific threshold, use the update endpoint. This endpoint is
 * subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Thresholds (32)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostThresholds = <ThrowOnError extends boolean = true>(options: Options<PostApiV1ThresholdsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ThresholdsResponses, PostApiV1ThresholdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/thresholds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Default Thresholds
 *
 * List all Seerlinq-wide default thresholds. These thresholds are defined in
 * the `common` code and are shared across all relevant components of the
 * Seerlinq stack (notably, the same thresholds are used for algorithms inside
 * `codebase` repository).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiGetThresholdsDefault = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1ThresholdsDefaultData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ThresholdsDefaultResponses, GetApiV1ThresholdsDefaultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/thresholds/default',
    ...options
});

/**
 * Delete Threshold
 *
 * Delete patient-specific threshold by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiDeleteThresholdsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1ThresholdsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1ThresholdsByUuidResponses, DeleteApiV1ThresholdsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/thresholds/{uuid}',
    ...options
});

/**
 * Update Threshold
 *
 * Update/edit patient-specific threshold given its UUID. Upon updating, the
 * old threshold value is saved to the threshold history, which is a simple
 * list with change dates and old values. The **admin** role can update all
 * thresholds and **monitoring** users can update patient thresholds based on
 * their visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Thresholds (32)` <br /> See the _API description_ for more info.
 */
export const apiPutThresholdsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1ThresholdsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1ThresholdsByUuidResponses, PutApiV1ThresholdsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/thresholds/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Event Categories
 *
 * List all event categories, their relevant category types and category
 * details.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiGetEventsCategories = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1EventsCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1EventsCategoriesResponses, GetApiV1EventsCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/events/categories',
    ...options
});

/**
 * Get Events
 *
 * List all patients' events in the DB. It is possible to filter by patient
 * IDs, types of events, and search string based on the `event_description`
 * field (we use the `glob` syntax, where `*` matches any characters) This
 * endpoint is subject to filtering by data visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiGetEvents = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1EventsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1EventsResponses, GetApiV1EventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/events',
    ...options
});

/**
 * Create Event
 *
 * Create new patient event. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `View Events (33)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostEvents = <ThrowOnError extends boolean = true>(options: Options<PostApiV1EventsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1EventsResponses, PostApiV1EventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Event
 *
 * Delete patient event by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiDeleteEventsUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1EventsByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1EventsByUuidResponses, DeleteApiV1EventsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/events/{uuid}',
    ...options
});

/**
 * Update Event
 *
 * Update/edit patient event given its UUID. The **admin** role can update all
 * events and **monitoring** users can update patient events based on their
 * visibility.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Update Visible (4)`, `View Events (33)` <br /> See the _API description_ for more info.
 */
export const apiPutEventsUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1EventsByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1EventsByUuidResponses, PutApiV1EventsByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/events/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Messages
 *
 * List all messages belonging to _any_ patient ID. A **self-only** user role
 * cannot list all messages, rather they can use a specific endpoint with
 * the patient ID as the path parameter to get the last message for a
 * particular patient ID. It is possible to filter filter by patient IDs and
 * whether messages are active. This endpoint is subject to filtering by data
 * visibility dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMessaging = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MessagingData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MessagingResponses, GetApiV1MessagingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging',
    ...options
});

/**
 * Create Message
 *
 * Create a new message. This endpoint is subject to filtering by data
 * visibility dimension. A **self-only** user role cannot create a new message.
 * This endpoint also sets all previous messages for a patient as deactivated
 * (regardless of their expiry), i.e., only **one** message per patient can be
 * active at any given time.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMessaging = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MessagingData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MessagingResponses, PostApiV1MessagingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Last Message
 *
 * Get the last active message for a given patient ID. If the message expires,
 * it will be returned, but the message status will list it as expired. There
 * is no difference between no messages whatsoever and all messages being
 * deactivated. This endpoint is subject to filtering by data visibility
 * dimension.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMessagingPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MessagingByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MessagingByPatientIdResponses, GetApiV1MessagingByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/{patient_id}',
    ...options
});

/**
 * Delete Message
 *
 * Delete a message by its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteMessagingUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MessagingByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MessagingByUuidResponses, DeleteApiV1MessagingByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/{uuid}',
    ...options
});

/**
 * Update Message
 *
 * Update/edit a message given its UUID. The **admin** role can update all
 * messages, while lower access levels can update only messages they created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMessagingUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MessagingByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MessagingByUuidResponses, PutApiV1MessagingByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/messaging/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Study Texts
 *
 * Get the list of study texts.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetStudyText = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1StudyTextData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1StudyTextResponses, GetApiV1StudyTextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/study-text',
    ...options
});

/**
 * Create Study Text
 *
 * Create a new Seerlinq study text. It is possible to create study texts that
 * require patient info. In that case, define study text string using `python`
 * string formatting, so e.g., `This is sample text {patient.patient_id}` will
 * return text with patient ID of the patient model filled in. For now, the
 * only allowed field is `patient` and will be filled automatically.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostStudyText = <ThrowOnError extends boolean = true>(options: Options<PostApiV1StudyTextData, ThrowOnError>) => (options.client ?? client).post<PostApiV1StudyTextResponses, PostApiV1StudyTextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/study-text',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * About Seerlinq
 *
 * Get "About Seerlinq" text.
 */
export const apiGetStudyTextAboutTextLanguage = <ThrowOnError extends boolean = true>(options: Options<GetApiV1StudyTextAboutByTextByLanguageData, ThrowOnError>) => (options.client ?? client).get<GetApiV1StudyTextAboutByTextByLanguageResponses, GetApiV1StudyTextAboutByTextByLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/study-text/about/{text}/{language}',
    ...options
});

/**
 * Get Study Text
 *
 * Get the latest version of a informed consent text given the **Monitoring
 * Type** and required language. Languages are coded as _locale_ strings, where
 * the language code is lowercase and per ISO 639-1, and the locale is optional
 * and uppercase. E.g., `sk` will give Slovak text, and `en-US` will give
 * American English text. The `fill_in_patient_info` controls whether the study
 * text requires to fill in the specific patient info. If set to `True`,
 * `patient_id` parameter must be defined. In this case the correct study text
 * if looked up using more information from the patient as per patient's
 * country, region, clinic, and physician UUID, with the fallback to the
 * default text. For patient-specific study text, the monitoring type path
 * parameter is effectively ignored, and text lookup is done on patient's
 * monitoring type. In this case, the endpoint loads patient database model and
 * formats the study text.
 */
export const apiGetStudyTextMonitoringTypeTextLanguage = <ThrowOnError extends boolean = true>(options: Options<GetApiV1StudyTextByMonitoringTypeByTextLanguageData, ThrowOnError>) => (options.client ?? client).get<GetApiV1StudyTextByMonitoringTypeByTextLanguageResponses, GetApiV1StudyTextByMonitoringTypeByTextLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/study-text/{monitoring_type}/{text_language}',
    ...options
});

/**
 * Delete Study Text
 *
 * Delete a Seerlinq study text given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> See the _API description_ for more info.
 */
export const apiDeleteStudyTextUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1StudyTextByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1StudyTextByUuidResponses, DeleteApiV1StudyTextByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/study-text/{uuid}',
    ...options
});

/**
 * Update Study Text
 *
 * Update/edit a Seerlinq study text given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutStudyTextUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1StudyTextByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1StudyTextByUuidResponses, PutApiV1StudyTextByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/study-text/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Limiters
 *
 * Get the list of all access limiters.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetLimiters = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1LimitersData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1LimitersResponses, GetApiV1LimitersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/limiters',
    ...options
});

/**
 * Create Limiter
 *
 * Create a new access limiter.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostLimiters = <ThrowOnError extends boolean = true>(options: Options<PostApiV1LimitersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1LimitersResponses, PostApiV1LimitersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/limiters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Limiter
 *
 * Delete an access limiter given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteLimitersUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1LimitersByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1LimitersByUuidResponses, DeleteApiV1LimitersByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/limiters/{uuid}',
    ...options
});

/**
 * Update Limiter
 *
 * Update/edit an access limiter given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPutLimitersUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1LimitersByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1LimitersByUuidResponses, PutApiV1LimitersByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/limiters/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Push Notifications To Users
 *
 * Send push notification to multiple users by UUID.
 * Sends to all registered devices for all targeted users.
 *
 * Notes:
 * - Queues ticket IDs for later receipt verification by cron job (~15 min)
 * - Invalid tokens will be removed when receipts indicate delivery failure
 * - Returns success if Expo accepts the request
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPushNotificationsSend = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PushNotificationsSendData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PushNotificationsSendResponses, PostApiV1PushNotificationsSendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-notifications/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Push Notification To Patient
 *
 * Send push notification to a single patient by ID, to every device of the
 * patient's connected accounts.
 *
 * Notes:
 * - `path` is passed through to the client as `data.path` for deep linking
 * - recorded in the notification ledger as `kind=manual`, in `language` or
 * else the language of an account it reaches, and audited as a note naming
 * the sending admin
 * - Returns 404 when the patient has no device registered; a send Expo
 * refused for every device answers 200 with 0 queued
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPushNotificationsSendToPatient = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PushNotificationsSendToPatientData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PushNotificationsSendToPatientResponses, PostApiV1PushNotificationsSendToPatientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-notifications/send-to-patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Templated Push Notification
 *
 * Send one of the notification engine's own messages, rendered from
 * `notifications.json`, without waiting for the event that would trigger it.
 *
 * Notes:
 * - only `user_uuid`'s own devices are addressed
 * - the ledger row is `kind=manual` with a `manual:<uuid>` key, so a copy
 * review never consumes a real event
 * - `force` sends outside the 05:00-21:59 local window
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostPushNotificationsSendTemplated = <ThrowOnError extends boolean = true>(options: Options<PostApiV1PushNotificationsSendTemplatedData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PushNotificationsSendTemplatedResponses, PostApiV1PushNotificationsSendTemplatedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-notifications/send-templated',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Patient Notification Log
 *
 * What each patient was told, when, and in which language: the ledger, paged
 * by `limit` and `offset`, with `total` for the rows the filters match.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetPushNotificationsLog = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1PushNotificationsLogData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PushNotificationsLogResponses, GetApiV1PushNotificationsLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/push-notifications/log',
    ...options
});

/**
 * Is Api Task Ready
 *
 * Check whether background API task is ready.
 */
export const apiGetTasksApiStatusTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksApiStatusByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksApiStatusByTaskIdResponses, GetApiV1TasksApiStatusByTaskIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/api/status/{task_id}',
    ...options
});

/**
 * Get All Api Task Ids
 *
 * List all task IDs that are saved in the result backend.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksApiTaskIds = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1TasksApiTaskIdsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TasksApiTaskIdsResponses, GetApiV1TasksApiTaskIdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/api/task-ids',
    ...options
});

/**
 * Get Api Task Result
 *
 * Get info on the background API task result. For a user with **medical
 * access** or below, this returns whether the task is done and whether it
 * errored (and if so, the stacktrace). For a user with **monitoring access**
 * and higher, it also returns the full result, including logs - unless the
 * task was kicked with `hide_result`.
 */
export const apiGetTasksApiResultTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksApiResultByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksApiResultByTaskIdResponses, GetApiV1TasksApiResultByTaskIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/api/result/{task_id}',
    ...options
});

/**
 * Worker Task Status
 *
 * Check status of background `celery` task.
 */
export const apiGetTasksWorkerStatusTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerStatusByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerStatusByTaskIdResponses, GetApiV1TasksWorkerStatusByTaskIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/status/{task_id}',
    ...options
});

/**
 * Get Worker Task Result
 *
 * Get info on the background `celery` task result. For a user without **admin
 * access**, this returns the task status, date time when the task was
 * finished (or failed), and the error stacktrace if the task failed. For a
 * user with **admin access**, it also returns the full result as returned
 * by Seerlinq algorithms.
 */
export const apiGetTasksWorkerResultTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerResultByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerResultByTaskIdResponses, GetApiV1TasksWorkerResultByTaskIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/result/{task_id}',
    ...options
});

/**
 * Render Quicklook Html Worker Result
 *
 * Render the result of a _QuickLook_ `celery` task as a HTML page.
 * Access is checked against specific QuickLook permissions based on the
 * algorithm type.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerQuicklookByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerQuicklookByTaskIdResponses, GetApiV1TasksWorkerQuicklookByTaskIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/{task_id}',
    ...options
});

/**
 * Render Quicklook Pdf Worker Result
 *
 * Render the result of a _QuickLook_ `celery` task as a PDF file.
 * Access is checked against specific QuickLook permissions based on the
 * algorithm type. To obtain a PDF result, submit the task with
 * `report_format=pdf`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookTaskIdPdf = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerQuicklookByTaskIdPdfData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerQuicklookByTaskIdPdfResponses, GetApiV1TasksWorkerQuicklookByTaskIdPdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/{task_id}/pdf',
    ...options
});

/**
 * Render Quicklook Json Worker Result
 *
 * Render the result of a _QuickLook_ `celery` task as a JSON report.
 * Access is checked against specific QuickLook permissions based on the
 * algorithm type. **HeartCore Master** reports are additionally filtered
 * per viewer: only sections the rendering user's permission bits allow
 * (matched on `section_key`) are returned. To obtain a JSON result, submit
 * the task with `report_format=json`.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookTaskIdJson = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerQuicklookByTaskIdJsonData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerQuicklookByTaskIdJsonResponses, GetApiV1TasksWorkerQuicklookByTaskIdJsonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/{task_id}/json',
    ...options
});

/**
 * Share Quicklook Analysis
 *
 * Share the result of a _QuickLook_ `celery` task externally. THis endpoint
 * will generate a URL containing one-time tokens and anyone with the correct
 * URL will be able to see the analysis without being logged in. The token
 * expires after 1:00:00 hours.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerQuicklookShareTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerQuicklookShareByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerQuicklookShareByTaskIdResponses, GetApiV1TasksWorkerQuicklookShareByTaskIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/share/{task_id}',
    ...options
});

/**
 * Render Shared Quicklook Html Worker Result
 *
 * Render the result of a **shared** _QuickLook_ `celery` task as a HTML page.
 * Note, that anyone with the correct link will be able to see this analysis.
 * The one-time tokens are provided as query parameters and the token expires
 * after 1:00:00 hours.
 */
export const apiGetTasksWorkerQuicklookSharedTaskId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1TasksWorkerQuicklookSharedByTaskIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TasksWorkerQuicklookSharedByTaskIdResponses, GetApiV1TasksWorkerQuicklookSharedByTaskIdErrors, ThrowOnError>({ url: '/api/v1/tasks/worker/quicklook/shared/{task_id}', ...options });

/**
 * Get All Celery Tasks And Queues
 *
 * List all registered `celery` tasks.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerListTasks = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1TasksWorkerListTasksData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TasksWorkerListTasksResponses, GetApiV1TasksWorkerListTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/list-tasks',
    ...options
});

/**
 * Get Quicklook Celery Tasks
 *
 * List _QuickLook_ `celery` tasks, i.e., tasks that return HTML analysis and
 * can be submitted and inspected by users with **monitoring access**
 * and higher.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Monitoring Routers (11)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetTasksWorkerListQuicklookTasks = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1TasksWorkerListQuicklookTasksData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TasksWorkerListQuicklookTasksResponses, GetApiV1TasksWorkerListQuicklookTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/list-quicklook-tasks',
    ...options
});

/**
 * Submit Ppg Worker Task
 *
 * Submit background `celery` task. This endpoints allows submitting any task
 * that have PPGs as an task input, and is only for admins. When you are
 * **monitoring** user and want to submit a _QuickLook_ analysis task, see
 * `tasks/worker/quicklook/ppg` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerSubmitPpg = <ThrowOnError extends boolean = true>(options: Options<PostApiV1TasksWorkerSubmitPpgData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TasksWorkerSubmitPpgResponses, PostApiV1TasksWorkerSubmitPpgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/submit/ppg',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Patient Worker Task
 *
 * Submit background `celery` task. This endpoints allows submitting any task
 * that have patient IDs as an task input, and is only for admins. When you are
 * **monitoring** user and want to submit a _QuickLook_ analysis task, see
 * `tasks/worker/quicklook/patient` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerSubmitPatient = <ThrowOnError extends boolean = true>(options: Options<PostApiV1TasksWorkerSubmitPatientData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TasksWorkerSubmitPatientResponses, PostApiV1TasksWorkerSubmitPatientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/submit/patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Ppg Worker Workflow
 *
 * Submit background registered `celery` workflows. This endpoint allows
 * submitting one of registered Seerlinq DAG workflow and is only for admins.
 * If you want to submit a custom workflow, see `tasks/workflow/build`
 * endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkflowSubmit = <ThrowOnError extends boolean = true>(options: Options<PostApiV1TasksWorkflowSubmitData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TasksWorkflowSubmitResponses, PostApiV1TasksWorkflowSubmitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/workflow/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Build And Submit Worker Workflow
 *
 * Build and submit background `celery` workflow. This endpoint allows
 * submitting tasks in a custom DAG workflow and is only for admins.
 * Tasks in workflow can receive arguments and keyword arguments.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkflowBuild = <ThrowOnError extends boolean = true>(options: Options<PostApiV1TasksWorkflowBuildData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TasksWorkflowBuildResponses, PostApiV1TasksWorkflowBuildErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/workflow/build',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Ppg Quicklook Task
 *
 * Submit a _QuickLook_ analysis task with PPGs as an input. _QuickLook_ tasks
 * are tasks that return valid HTML page containing the tables and plots
 * resulting from the analysis. For rendering the final analysis (when the task
 * is ready), use the
 * `tasks/worker/quicklook/{task_id}` endpoint (HTML),
 * `tasks/worker/quicklook/{task_id}/pdf` (PDF), or
 * `tasks/worker/quicklook/{task_id}/json` (JSON).
 *
 * Permission is checked based on the task type:
 * - PPG timeseries / AUC / beats tasks require `PPG_RAW`
 * - AFib task requires `AFIB` (on top of `PPG_RAW`)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Ppg Raw (42)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerQuicklookPpg = <ThrowOnError extends boolean = true>(options: Options<PostApiV1TasksWorkerQuicklookPpgData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TasksWorkerQuicklookPpgResponses, PostApiV1TasksWorkerQuicklookPpgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/ppg',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Patient Quicklook Task
 *
 * Submit a _QuickLook_ analysis task with patient IDs as an input. _QuickLook_
 * tasks are tasks that return valid HTML page containing the tables and plots
 * resulting from the analysis. For rendering the final analysis (when the task
 * is ready), use the
 * `tasks/worker/quicklook/{task_id}` endpoint (HTML),
 * `tasks/worker/quicklook/{task_id}/pdf` (PDF), or
 * `tasks/worker/quicklook/{task_id}/json` (JSON).
 *
 * Permission is checked based on the task type:
 * - DRI tasks require `ACCESS_DRI`
 * - LVFP tasks require `ACCESS_LVFP`
 * - HeartCore tasks require `RUN_HEART_CORE_QUICKLOOK`
 *
 * The **HeartCore Master** _QuickLook_ cannot be submitted here — use the
 * dedicated `tasks/worker/quicklook/heartcore-master/{patient_id}` endpoint,
 * which computes the per-section permission allowlist.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiPostTasksWorkerQuicklookPatient = <ThrowOnError extends boolean = true>(options: Options<PostApiV1TasksWorkerQuicklookPatientData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TasksWorkerQuicklookPatientResponses, PostApiV1TasksWorkerQuicklookPatientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/patient',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Heartcore Quicklook
 *
 * Submit Seerlinq's famed _QuickLook_ analysis **HeartCore** report for a
 * given patient ID. _QuickLook_ tasks are tasks that return valid HTML page
 * containing the tables and plots resulting from the analysis. For rendering
 * the final analysis (when the task is ready), use the
 * `tasks/worker/quicklook/{task_id}` endpoint (HTML),
 * `tasks/worker/quicklook/{task_id}/pdf` (PDF), or
 * `tasks/worker/quicklook/{task_id}/json` (JSON).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Run Heart Core Quicklook (41)` <br /> See the _API description_ for more info.
 */
export const apiPutTasksWorkerQuicklookHeartcorePatientId = <ThrowOnError extends boolean = true>(options: Options<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdResponses, PutApiV1TasksWorkerQuicklookHeartcoreByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/heartcore/{patient_id}',
    ...options
});

/**
 * Submit Heartcore Master Quicklook
 *
 * Submit the **HeartCore Master** _QuickLook_ analysis for a given patient ID,
 * i.e., the JSON-only union of all patient-level report sections. The rendered
 * sections are the *permitted* sections minus `skip_sections`, where permitted
 * is derived from the user's permission bits. For rendering the final analysis
 * (when the task is ready), use the
 * `tasks/worker/quicklook/{task_id}/json` endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Run Heart Core Quicklook (41)` <br /> See the _API description_ for more info.
 */
export const apiPutTasksWorkerQuicklookHeartcoreMasterPatientId = <ThrowOnError extends boolean = true>(options: Options<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdResponses, PutApiV1TasksWorkerQuicklookHeartcoreMasterByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/worker/quicklook/heartcore-master/{patient_id}',
    ...options
});

/**
 * Get Countries Regions
 *
 * List countries and their regions.
 *
 * Uses common_name where available (e.g., "South Korea" not
 * "Korea, Republic of").
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetUtilsCountries = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1UtilsCountriesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1UtilsCountriesResponses, GetApiV1UtilsCountriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/utils/countries',
    ...options
});

/**
 * Get Error Codes
 *
 * Get all error codes and their corresponding messages.
 *
 * This endpoint is used by frontend clients to load error messages
 * based on the user's selected language.
 */
export const apiGetUtilsErrorCodesLanguage = <ThrowOnError extends boolean = true>(options: Options<GetApiV1UtilsErrorCodesByLanguageData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UtilsErrorCodesByLanguageResponses, GetApiV1UtilsErrorCodesByLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/utils/error-codes/{language}',
    ...options
});

/**
 * Get Monitoring Settings List
 *
 * Get the list of all monitoring settings.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMonitoringSettingsMonitoring = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MonitoringSettingsMonitoringData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MonitoringSettingsMonitoringResponses, GetApiV1MonitoringSettingsMonitoringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/monitoring',
    ...options
});

/**
 * Create Monitoring Settings
 *
 * Create a new monitoring settings set. The monitoring settings for a given
 * monitoring type, country, region, clinic, and physician must be unique. To
 * update settings for the given audience, use the update endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMonitoringSettingsMonitoring = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MonitoringSettingsMonitoringData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MonitoringSettingsMonitoringResponses, PostApiV1MonitoringSettingsMonitoringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/monitoring',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Monitoring Settings For Patient
 *
 * Get monitoring settings set for a given patient ID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMonitoringSettingsMonitoringPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1MonitoringSettingsMonitoringByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1MonitoringSettingsMonitoringByPatientIdResponses, GetApiV1MonitoringSettingsMonitoringByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/monitoring/{patient_id}',
    ...options
});

/**
 * Delete Monitoring Settings
 *
 * Delete an monitoring settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteMonitoringSettingsMonitoringUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MonitoringSettingsMonitoringByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MonitoringSettingsMonitoringByUuidResponses, DeleteApiV1MonitoringSettingsMonitoringByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/monitoring/{uuid}',
    ...options
});

/**
 * Update Monitoring Settings
 *
 * Update/edit a monitoring settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMonitoringSettingsMonitoringUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MonitoringSettingsMonitoringByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MonitoringSettingsMonitoringByUuidResponses, PutApiV1MonitoringSettingsMonitoringByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/monitoring/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Questionnaires Automaton Settings
 *
 * Get the list of all questionnaire automaton settings.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetMonitoringSettingsQuestionnaires = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MonitoringSettingsQuestionnairesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MonitoringSettingsQuestionnairesResponses, GetApiV1MonitoringSettingsQuestionnairesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/questionnaires',
    ...options
});

/**
 * Create Questionnaires Automaton Settings
 *
 * Create a new questionnaire automaton settings set. The questionnaire
 * automaton settings for a given questionnaire ID (type), monitoring type,
 * country, region, clinic, and physician must be unique. To update settings
 * for the given audience and questionnaire type, use the update endpoint.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostMonitoringSettingsQuestionnaires = <ThrowOnError extends boolean = true>(options: Options<PostApiV1MonitoringSettingsQuestionnairesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1MonitoringSettingsQuestionnairesResponses, PostApiV1MonitoringSettingsQuestionnairesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/questionnaires',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Questionnaires Automaton Settings
 *
 * Delete a questionnaire automaton settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteMonitoringSettingsQuestionnairesUuid = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1MonitoringSettingsQuestionnairesByUuidData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1MonitoringSettingsQuestionnairesByUuidResponses, DeleteApiV1MonitoringSettingsQuestionnairesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/questionnaires/{uuid}',
    ...options
});

/**
 * Update Questionnaires Automaton Settings
 *
 * Update/edit a monitoring settings set given its UUID.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutMonitoringSettingsQuestionnairesUuid = <ThrowOnError extends boolean = true>(options: Options<PutApiV1MonitoringSettingsQuestionnairesByUuidData, ThrowOnError>) => (options.client ?? client).put<PutApiV1MonitoringSettingsQuestionnairesByUuidResponses, PutApiV1MonitoringSettingsQuestionnairesByUuidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/monitoring-settings/questionnaires/{uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clean Audit Logs
 *
 * Clean a selected query of audit logs. It is possible to filter by the audit
 * table, item UUID, audit item action (`update` or `delete`), audit tags,
 * audit user UUID, and specifying to -- from datetimes.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Delete Visible (6)`, `Group Admin Routers (12)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiDeleteAudit = <ThrowOnError extends boolean = true>(options?: Options<DeleteApiV1AuditData, ThrowOnError>) => (options?.client ?? client).delete<DeleteApiV1AuditResponses, DeleteApiV1AuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit',
    ...options
});

/**
 * Get Audit Logs
 *
 * List all audit items in the DB. An audit item is a historical record of
 * either an updated or deleted row. It is possible to filter by the audit
 * table, item UUID, audit item action (`update` or `delete`), audit tags,
 * audit user UUID, and specifying to -- from datetimes.
 *
 * When `audit_table` is given, `create` items are synthesized from the
 * source table's `created_at` (creation is never written to the audit
 * table). They carry no tags, so any `audit_tags` filter excludes them.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetAudit = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AuditData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuditResponses, GetApiV1AuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit',
    ...options
});

/**
 * Add Tags To Audit Logs
 *
 * Add tags to a selected query of audit logs. It is possible to filter by the
 * audit table, item UUID, audit item action (`update` or `delete`), audit
 * tags, audit user UUID, and specifying to -- from datetimes.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Update Visible (4)` <br /> See the _API description_ for more info.
 */
export const apiPutAudit = <ThrowOnError extends boolean = true>(options: Options<PutApiV1AuditData, ThrowOnError>) => (options.client ?? client).put<PutApiV1AuditResponses, PutApiV1AuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/audit',
    ...options
});

/**
 * Get Counts Seerlinq Computed
 *
 * Get counts of Seerlinq-computed data per given temporal grouping frequency.
 * This will group all data from Seerlinq-computed table by time and by
 * measurement type and count number of records and unique patients (by
 * computing unique items by patient ID). Optionally, filtering by datetimes is
 * possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsComputed = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AnalyticsComputedData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AnalyticsComputedResponses, GetApiV1AnalyticsComputedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/computed',
    ...options
});

/**
 * Get Counts Ppg Data
 *
 * Get counts of PPG data per given temporal grouping frequency. This will
 * group all data from PPG table by time, measurement device, and measurement
 * condition and count number of records and unique patients (by computing
 * unique items by patient ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsPpg = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AnalyticsPpgData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AnalyticsPpgResponses, GetApiV1AnalyticsPpgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/ppg',
    ...options
});

/**
 * Get Counts Ecg Data
 *
 * Get counts of ECG data per given temporal grouping frequency. This will
 * group all data from ECG table by time and by measurement device and count
 * number of records and unique patients (by computing unique items by patient
 * ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsEcg = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AnalyticsEcgData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AnalyticsEcgResponses, GetApiV1AnalyticsEcgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/ecg',
    ...options
});

/**
 * Get Counts Events
 *
 * Get counts of events data per given temporal grouping frequency. This will
 * group all data from patient's event table by time and by event category,
 * event category type, event category details, and count number of records and
 * unique patients (by computing unique items by patient ID). Optionally,
 * filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsEvents = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AnalyticsEventsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AnalyticsEventsResponses, GetApiV1AnalyticsEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/events',
    ...options
});

/**
 * Get Counts Audit Items
 *
 * Get counts of audit items per given temporal grouping frequency. This will
 * group all data from audit table by time and by measurement type and count
 * number of records and unique patients (by computing unique items by patient
 * ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsAudit = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AnalyticsAuditData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AnalyticsAuditResponses, GetApiV1AnalyticsAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/audit',
    ...options
});

/**
 * Get Counts Alert Items
 *
 * Get counts of alert items per given temporal grouping frequency. This will
 * group all data from alert table by time and by measurement type and count
 * number of records and unique patients (by computing unique items by patient
 * ID). Optionally, filtering by datetimes is possible.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Read (1)`, `View Analytics (35)` <br /> See the _API description_ for more info.
 */
export const apiGetAnalyticsAlerts = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1AnalyticsAlertsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AnalyticsAlertsResponses, GetApiV1AnalyticsAlertsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/analytics/alerts',
    ...options
});

/**
 * Get My Account
 *
 * Your billing account and its credit balance. 404 for an account that has
 * none; a screening account gets one when it is created.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Allow Payment (56)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingAccount = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1BillingAccountData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1BillingAccountResponses, GetApiV1BillingAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/account',
    ...options
});

/**
 * Get Ledger
 *
 * Every credit change on your account, newest first: a spend for each flow
 * whose result was delivered, and adjustments by an admin. Ledger rows never
 * change, so every sort is by creation. Empty for an account that has none.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Allow Payment (56)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingLedger = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1BillingLedgerData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1BillingLedgerResponses, GetApiV1BillingLedgerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/ledger',
    ...options
});

/**
 * Create Payment User
 *
 * Register a paid-screening account: a login that records PPG measurements
 * and pays for each delivered result from its credits. **Only `username`,
 * `password` and `email` are required**; `initial_credits` defaults to
 * 101. The patient and physician rows are filled in with fixed stand-ins
 * (name "Screening Account", country Slovakia, date of birth 1900-01-01,
 * sex `other`, race `Unknown / Not Reported`, no phone), because none of
 * it describes a real person.
 *
 * One call creates everything the account needs:
 *
 * - the login, with the permission that opens the paid-screening feature
 * - the patient the measurements hang off, as its own `screening`
 * monitoring type, so it stays out of the waiting room, the alerts and
 * the reminder emails; staff still see it in `GET /patients/` and its
 * physician in `GET /physicians/`
 * - the physician record connecting the login to that patient, which is
 * what makes those measurements visible to this account and no other
 * - the billing account with the starting credits
 *
 * Usernames are unique, so repeating the call with the same one is refused
 * rather than creating a second set. The caller must hold every
 * permission the account is given.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> This endpoint requires a **fresh** access token. Fresh access tokens are returned from `login` and `fresh-login`endpoints, _not_ the `refresh` endpoint. <br /> See the _API description_ for more info.
 */
export const apiPostBillingUsers = <ThrowOnError extends boolean = true>(options: Options<PostApiV1BillingUsersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1BillingUsersResponses, PostApiV1BillingUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Screening Users
 *
 * Every paid-screening user with what provisioning should have given them:
 * the permission, the physician record, the patient, the account and its
 * balance, credits spent and recordings stored. `missing` is empty exactly
 * when the account works end to end, so an account broken after
 * provisioning shows here; repair it with the ordinary user, patient and
 * physician endpoints, then `PUT /billing/users/{uuid}/credits`.
 *
 * Listed by role: the permission bitmask cannot be masked in SQL reliably.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingScreeningUsers = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1BillingScreeningUsersData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1BillingScreeningUsersResponses, GetApiV1BillingScreeningUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/screening-users',
    ...options
});

/**
 * Get User Account
 *
 * A user's billing account and its credit balance. 404 for an unknown
 * user, or one with no billing account.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetBillingUsersUserUuidAccount = <ThrowOnError extends boolean = true>(options: Options<GetApiV1BillingUsersByUserUuidAccountData, ThrowOnError>) => (options.client ?? client).get<GetApiV1BillingUsersByUserUuidAccountResponses, GetApiV1BillingUsersByUserUuidAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/users/{user_uuid}/account',
    ...options
});

/**
 * Set Credits
 *
 * Put a screening account's credits at an exact figure. The difference is
 * posted to the ledger under the given note, so the balance is still the
 * sum of its entries; the account is locked while the difference is worked
 * out, so a recording charged at the same moment is never overwritten. A
 * balance that already matches returns null, so repeating a request
 * changes nothing.
 *
 * Refused for a user who is not a screening account, 404 for one with no
 * billing account.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Admin Routers (12)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPutBillingUsersUserUuidCredits = <ThrowOnError extends boolean = true>(options: Options<PutApiV1BillingUsersByUserUuidCreditsData, ThrowOnError>) => (options.client ?? client).put<PutApiV1BillingUsersByUserUuidCreditsResponses, PutApiV1BillingUsersByUserUuidCreditsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/billing/users/{user_uuid}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Comorbidities
 *
 * List all comorbidities for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. If `full=true`, this endpoint
 * returns all tracked comorbidities (when not found in DB, it will assume a
 * "No" value).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfComorbiditiesPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1HfComorbiditiesByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1HfComorbiditiesByPatientIdResponses, GetApiV1HfComorbiditiesByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/comorbidities/{patient_id}',
    ...options
});

/**
 * Create Comorbidities
 *
 * Create new comorbidities in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 * Extra validation will not allow diagnoses not part of the HF validation
 * study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfComorbidities = <ThrowOnError extends boolean = true>(options: Options<PostApiV1HfComorbiditiesData, ThrowOnError>) => (options.client ?? client).post<PostApiV1HfComorbiditiesResponses, PostApiV1HfComorbiditiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/comorbidities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Vitals
 *
 * List all vital data for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns only medical
 * data that are marked as **vitals**, i.e., heart rate, systolic and diastolic
 * blood pressure, and SpO2. Note that this endpoint only returns SpO2 added to
 * the database as medical data, NOT SpO2 computed from PPG (which is part of
 * the PPG-derived table).
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfVitalsPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1HfVitalsByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1HfVitalsByPatientIdResponses, GetApiV1HfVitalsByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/vitals/{patient_id}',
    ...options
});

/**
 * Get Lab Data
 *
 * List all lab data for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns only medical
 * data that are marked as **lab data**, i.e., NT-proBNP, BNP, urea,
 * creatinine, hemoglobin, and hematocrit. Moreover, it automatically
 * computes (where the data is available) extra variables:
 *
 * * ePVS
 * * CKD-EPI (glomerular filtration rate estimate)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfLabDataPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1HfLabDataByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1HfLabDataByPatientIdResponses, GetApiV1HfLabDataByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/lab-data/{patient_id}',
    ...options
});

/**
 * Get Basic Medical Data
 *
 * List all basic medical data for a given patient ID. This endpoint is subject
 * to filtering by data visibility dimension. This endpoint returns only
 * medical data that are marked as **basic medical data**, i.e., weight, dry
 * weight, temperature, and respiratory rate. Moreover, it automatically
 * computes (where the data is available) extra variables:
 *
 * * CHA2DS2-VA score (Atrial Fibrillation Stroke Risk)
 * * BMI
 * * BSA (body surface area) (Du Bois formula)
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfBasicMedDataPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1HfBasicMedDataByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1HfBasicMedDataByPatientIdResponses, GetApiV1HfBasicMedDataByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/basic-med-data/{patient_id}',
    ...options
});

/**
 * Get Exams
 *
 * List all exams for a given patient ID. This endpoint is subject to
 * filtering by data visibility dimension. This endpoint returns only medical
 * data that are marked as **exams**, and includes all variables related to RHC
 * and ECHO examinations. Moreover, it automatically computes (where the data
 * is available) extra variables:
 *
 * * congestion score
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfExamsPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1HfExamsByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1HfExamsByPatientIdResponses, GetApiV1HfExamsByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/exams/{patient_id}',
    ...options
});

/**
 * Get Symptoms
 *
 * List all symptoms that are considered as HF-related for a given patient
 * ID. This endpoint is subject to filtering by data visibility dimension. This
 * endpoint returns only symptoms that are part of the HF validation study,
 * i.e., shortness of breath and fatigue score.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Read (1)` <br /> See the _API description_ for more info.
 */
export const apiGetHfSymptomsPatientId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1HfSymptomsByPatientIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1HfSymptomsByPatientIdResponses, GetApiV1HfSymptomsByPatientIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/symptoms/{patient_id}',
    ...options
});

/**
 * Create Data
 *
 * Create new medical data in bulk. This is possible only for a single patient
 * ID. This endpoint is subject to filtering by data visibility dimension.
 * Extra validation will not allow data types not part of the HF validation
 * study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfData = <ThrowOnError extends boolean = true>(options: Options<PostApiV1HfDataData, ThrowOnError>) => (options.client ?? client).post<PostApiV1HfDataResponses, PostApiV1HfDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/data',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Symptoms
 *
 * Create new study endpoints symptoms in bulk. This is possible only for a
 * single patient ID. This endpoint is subject to filtering by data visibility
 * dimension. Extra validation will not allow data types not part of the HF
 * validation study and at the same time all required measurements must be part
 * of the request.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfSymptoms = <ThrowOnError extends boolean = true>(options: Options<PostApiV1HfSymptomsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1HfSymptomsResponses, PostApiV1HfSymptomsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/symptoms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Rhc Exams Data
 *
 * Create new medical study RHC exams data in bulk. This is possible only for a
 * single patient ID. This endpoint is subject to filtering by data visibility
 * dimension. This endpoint is for medical study exams connected to the
 * right heart catheterization. Extra validation will not allow data types not
 * part of the HF validation study and at the same time all required
 * measurements (as per study protocol) must be part of the request.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfExamsRhc = <ThrowOnError extends boolean = true>(options: Options<PostApiV1HfExamsRhcData, ThrowOnError>) => (options.client ?? client).post<PostApiV1HfExamsRhcResponses, PostApiV1HfExamsRhcErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/exams/rhc',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Lhc Exams Data
 *
 * Create new medical study LHC exams data in bulk. This is possible only for a
 * single patient ID. This endpoint is subject to filtering by data visibility
 * dimension. This endpoint is for medical study exams connected to the
 * left heart catheterization. Extra validation will not allow data types not
 * part of the HF validation study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfExamsLhc = <ThrowOnError extends boolean = true>(options: Options<PostApiV1HfExamsLhcData, ThrowOnError>) => (options.client ?? client).post<PostApiV1HfExamsLhcResponses, PostApiV1HfExamsLhcErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/exams/lhc',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Echo Exams Data
 *
 * Create new medical study ECHO exams data in bulk. This is possible only for
 * a single patient ID. This endpoint is subject to filtering by data
 * visibility dimension. This endpoint is for medical study exams connected to
 * the echocardiogram. Extra validation will not allow data types not part of
 * the HF validation study.
 *
 * Required authorization for this endpoint: <br /> Required permissions: `Group Medical Routers (10)`, `Write (2)` <br /> See the _API description_ for more info.
 */
export const apiPostHfExamsEcho = <ThrowOnError extends boolean = true>(options: Options<PostApiV1HfExamsEchoData, ThrowOnError>) => (options.client ?? client).post<PostApiV1HfExamsEchoResponses, PostApiV1HfExamsEchoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hf/exams/echo',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health Check
 *
 * Simple API health check. No authentication required.
 */
export const apiGetHealthchecker = <ThrowOnError extends boolean = true>(options?: Options<GetApiHealthcheckerData, ThrowOnError>) => (options?.client ?? client).get<GetApiHealthcheckerResponses, unknown, ThrowOnError>({ url: '/api/healthchecker', ...options });

/**
 * Service Status
 *
 * API and connected services health. Return statuses and latency for overall
 * service, DB, Redis cache, and background tasks backend and broker.
 */
export const apiGetHealth = <ThrowOnError extends boolean = true>(options?: Options<GetApiHealthData, ThrowOnError>) => (options?.client ?? client).get<GetApiHealthResponses, unknown, ThrowOnError>({ url: '/api/health', ...options });

/**
 * Api Info
 *
 * Get basic info on the API: environment, version, base URL and server time.
 */
export const apiGetInfo = <ThrowOnError extends boolean = true>(options?: Options<GetApiInfoData, ThrowOnError>) => (options?.client ?? client).get<GetApiInfoResponses, GetApiInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/info',
    ...options
});
